import { ProcessStatePollingService } from "./../../../../shared/services/process-state-polling.service";
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, AfterViewInit, ViewChildren, QueryList, SkipSelf, Self, EventEmitter } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Subject, Subscription, Observable, combineLatest, interval } from "rxjs";
import {
  IAnswer,
  IAnswerWarning,
  IFormField,
  makeControlForQuestion,
  setupDependantMandatory
} from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { ActivatedRoute, Router } from "@angular/router";
import { TaxReturnsResolver } from "../../tax-returns-resolver";
import {
  AnswerService,
  AnswerTrace,
  CommentService,
  FlagService,
  ListOfFlags,
  Question,
  SmartFormTypeService,
  TaxReturnService,
  FileSystemService,
  ProcessStateService,
} from "../../../../../swaggerServices";
import { cloneDeep, maxBy } from "lodash-es";
import { IDocumentMetadata, ITaxReturn } from "../model/i-tax-return";
import { IComment } from "./comments/comments.component";
import {
  getActiveWarnings,
  getClosedWarnings,
  getClientRulesWarningMsg,
  getFullTaxReturn,
  handleUrlsForNewComment,
  resolveDocuments
} from "../../get-full-tax-return";
import { AttachmentsService, Folders } from "./comments/attachments/attachments.service";
import { findUrls, handleUrls } from "../urls";
import { UserInfoService } from "../../../user-info.service";
import moment from "moment";
import { ConfigStateService } from "../../../config/config-state.service";
import { IGroup, ICommentField, PastedDocMetadata, IAnswerFlag, IFlaggedAns,IReviewItem, ICommentWithAnswersTree, ISubGroup, ICommentAnswerRequestNode, IQuestionFocus } from "./subcategory";
import { TaxReturnSubcategoryService } from "./subcategory.service";
import { Tenant } from "../../../../shared/types/tenant.enum";
import { RubixDocumentsService } from "../rubix-documents/rubix-documents.service";
import { TenantConfigService } from "../../../../shared/services/tenant-config.service";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { getVisibleQuestionsInSmartForms } from "../../../settings/smart-forms/smart-form-logic-utils";
import { TaxReturnStatus } from "../model/status";
import { QuestionGroupCardComponent } from "./question-group-card/question-group-card.component";
import { of } from "rxjs";
import { filter, takeWhile } from "rxjs/operators";
import { RunCalcsService } from "../../../../shared/services/run-calcs.service";
import { TranslocoService} from "@jsverse/transloco";
import { CommentValue } from "./comments/attachments/attachments.component";
import { HttpClient, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from "@angular/common/http";
import { SubcategoryHttpInterceptor } from "./subcategory.interceptor";

declare var $: any;
const el = elementRef => $(elementRef.nativeElement);

const commentFieldsMatch = (cf1, cf2) => cf1.id === cf2.id && cf1.groupId === cf2.groupId && cf1.rowIndex == cf2.rowIndex;

interface IAnswerWarningWithComment {
  answerWarning: IAnswerWarning;
  comment: CommentValue;
}
@Component({
    selector: "app-subcategory",
    templateUrl: "./subcategory.component.html",
    styleUrls: ["./subcategory.component.scss"],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SubcategoryHttpInterceptor,
            multi: true,
        },
        {
            provide: HttpHandler,
            useFactory: (interceptors: HttpInterceptor[], parentHandler: HttpHandler) => {
                return interceptors.reduceRight((handler, interceptor) => {
                    const nextHandler = {
                        handle(req: HttpRequest<any>) {
                            return interceptor.intercept(req, handler);
                        },
                    };
                    return nextHandler;
                }, parentHandler);
            },
            // Use the local HTTP interceptors and parent HttpHandler so request can be forwarded to global
            // http interceptor afterwards
            deps: [[new Self(), HTTP_INTERCEPTORS], [new SkipSelf(), HttpHandler]],
        },
        {
            provide: HttpClient,
            useFactory: (handler: HttpHandler) => new HttpClient(handler),
            deps: [HttpHandler],
        },
        // Reprovide root services should be handled by the `SubcategoryHttpInterceptor` so they use
        // the local HttpClient that interfaces with the `SubcategoryHttpInterceptor`,  allowing
        // requests made by these services to be intercepted
        FileSystemService,
        AttachmentsService,
        TaxReturnService,
        AnswerService,
        CommentService,
        FlagService,
    ],
    standalone: false
})
export class SubcategoryComponent implements OnInit, OnDestroy, AfterViewInit {

  scrollPositions: Map<number, number> = new Map();
  scrollLeftPositions: Map<number, number> = new Map();
  scrollableElements: Map<number, ElementRef> = new Map();

  handleScroll(event: any, subgroupId: number ) {
    if (event.target.scrollTop !== 0) {
      this.scrollPositions.set(subgroupId, event.target.scrollTop);
    }
    if (event.target.scrollLeft !== 0) {
      this.scrollLeftPositions.set(subgroupId, event.target.scrollLeft);
    }
  }

  onModernTableScrollRefEmit(scrollRef: ElementRef, subgroupId: number) {
    this.scrollableElements.set(subgroupId, scrollRef);
  }

  firstLoad = true;
  subscriptions: Subscription[] = [];
  subcategorySubs: Subscription[] = [];
  newGroupFormGroup: UntypedFormGroup;
  activeGroup: IGroup; // current group in focus
  activeGroupsSelected: { [id: number]: IGroup } = {}; // groups saved as they are selected
  groupToDelete?: IGroup;
  lastActiveGroupId?: number;
  lastActiveGroupName?: string;
  lastActiveSubGroupId?: number;
  comments: IComment[] = [];
  commentFields: ICommentField[] = [];
  comment: UntypedFormControl; // comment input on save modal when fields have been edited
  commentsCount: number; // total comments for subcategory
  totalComments = 0; // total comments count for selected group or subgroup
  commentDocumentMetadatas: PastedDocMetadata[] = [];
  debugModeControl: UntypedFormControl = new UntypedFormControl();
  warningCount: number; // total warnings for subcategory
  hasGroupings: boolean; // whether subcategory has groupings tabs
  groupQuestion?: IFormField; // question field set as group tab
  taxReturn: ITaxReturn;
  subCategory: any = {};
  dependantMandatoryChanged: Subject<void> = new Subject<void>();
  dependantMandatoryChangedSub?: Subscription;
  activeGroupSub?: Subscription;
  isReady = false;
  isSaving: boolean;
  isRunningCalcs: boolean;
  isSyncingAps: boolean;
  private unsubscribe: Subject<void> = new Subject();
  isClearingOverrides: boolean;
  @ViewChild('editGroupModal') editGroupModal: ElementRef;
  @ViewChild('addGroupModal') addGroupModal: ElementRef;
  @ViewChild('deleteGroupModal') deleteGroupModal: ElementRef;
  @ViewChild('saveModal') saveModal: ElementRef;
  @ViewChild('calcResultsModal') calcResultsModal: ElementRef;
  @ViewChild('singleAnswerOverRideModal') singleAnswerOverRideModal: ElementRef;
  @ViewChild('clearOverridesModal') clearOverridesModal: ElementRef;
  calcResultsSummary: string[] = [];
  calcFailures: string[] = [];
  calcDebug: string[] = [];
  showCalcDebug: boolean = false;
  @ViewChild('unsavedFieldsModal') unsavedFieldsModal: ElementRef;
  @ViewChild('bulkReplyModal') bulkReplyModal: ElementRef;
  answerWarningsWithComments: IAnswerWarningWithComment[] = [];
  answerWarningMessages: string[] = [];
  currentAnswerWarning: IAnswerWarning;
  currentAnswerComment: CommentValue;
  shouldClose: boolean;
  @ViewChild('unsavedModal') unsavedModal: ElementRef;
  newGroupId = -1;
  defaultGroupName = 'untitled';
  newGroupTemplate?: IGroup;
  clickedCell: boolean;
  answerWarnings: IAnswerWarning[] = [];
  answerFlags: IAnswerFlag[] = [];
  answerFlagsFiltered: IAnswerFlag[] = [];
  answerFlagsFilteredClosed: IAnswerFlag[] = [];
  combinedReviewItems: IReviewItem[] = [];
  isSavingReply = false;
  showCalcPlanMessage = false;

  tab = 2; // default to comments tab
  getCommentMeta: Function; // shared to comments cmp
  pushComments: Function; // shared to comments cmp
  flaggedAns?: IFlaggedAns;
  flagsComment: UntypedFormControl;
  flagTypes: ListOfFlags;
  flagTypeId: number; // when adding new comment with flags
  @ViewChild('flagDropDown') flagDropDown: ElementRef;
  filteredDocuments: IDocumentMetadata[];
  replyingWarning = false;
  replyingFlag = false;
  showQuestionId: boolean;
  questionsById: {} = {};
  rightSideTab: 'activity' | 'calculation' = 'activity';
  trace?: AnswerTrace;
  traceQuestion?: Question;
  traceAnswer?: IAnswer;
  loadingTrace?: Subscription;
  // traceNotAvailable: boolean = false;
  configLoaded: boolean = false;
  isFullScreenMode: boolean = false;
  fullScreenSubGroup: any;
  subcatsInitated = false;
  uiConfig: TenantConfigService;
  isAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  inputQuestionId: number;
  fileQuestion: any[];
  smartForms: any = []
  visibleQuestions: any = {}
  clearOverrideModalMessage: string;
  manuallyEnteredAnswersPopupText: string;
  areYouSureYouWantToClearText: string;
  categoryName: string = "";
  folders: Folders = {
    rootFolder: "",
    attachmentsFolder: "",
    targetFolder: "",
  };
  modalImgSrc: string = "";

  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;
  private lastScrollPosition = 0;
  private lastScrollLeftPosition = 0;

  @ViewChildren(QuestionGroupCardComponent) questionGroupCards: QueryList<QuestionGroupCardComponent>;
  private tableScrollPositions = new Map<number, number>();
  private tableScrollLeftPositions = new Map<number, number>();

  @ViewChild(QuestionGroupCardComponent, { static: false }) questionGroupCardComponent: QuestionGroupCardComponent;

  set unsaved(value: boolean) {
    this._unsaved = value;
    this.unsavedChange.next(value);
  }

  get unsaved(): boolean {
    return this._unsaved;
  }

  private _unsaved: boolean;
  private unsavedChange = new Subject<boolean>();

  private navigationPending = false;

  canDeactivate(): Observable<boolean> {
    if (!this.unsaved) {
      return of(true);
    } else {
      this.navigationPending = true;
      $(this.unsavedModal.nativeElement).modal({
        onDeny: () => {
          this.navigationPending = false;
        },
      }).modal('show');

      return new Observable<boolean>((observer) => {
        this.unsavedChange.pipe(
          filter(unsaved => !unsaved)
        ).subscribe((unsaved) => {
          if (this.navigationPending) {
            observer.next(!unsaved);
            observer.complete();
          }
        });

        this.doNotSaveClicked.subscribe(() => {
          observer.next(true);
          observer.complete();
        });

        return () => {
          this.navigationPending = false;
        };
      });
    }
  }

  doNotSaveClicked = new EventEmitter();

  doNotSave() {
    this.doNotSaveClicked.emit();
  }

  _sideOpen = true;
  get sideOpen() {
    return this._sideOpen;
  }

  set sideOpen(open: boolean) {
    this._sideOpen = open;
    // NOTE(mike): super hack to fix the floatThead jquery plugin issue where it doesn't handle the resize
    // caused by opening/closing the side-block.
    window.dispatchEvent(new Event('resize'));
  }
  previousSideOpen = this.sideOpen

  get isLodged(): boolean {
    return (this.taxReturn && (
      this.taxReturn.status === TaxReturnStatus.LODGED.id ||
      this.taxReturn.status === TaxReturnStatus.AMENDMENT_LODGED.id ||
      this.taxReturn.status === TaxReturnStatus.REVISION_LODGED.id
    ));
  }

  get disableRunCalcForLodgedTaxReturn(): boolean {
    return this.config.featureFlags.disableRunCalcForLodgedTaxReturn;
  }

  debug = !!this.debugModeControl.value//false; // true to show hidden questions

  modernTable = false;
  @ViewChild('notesModal') notesModalEl: ElementRef;

  savedAnswersWithFlags: IAnswerFlag[] = []; // to prompt closing flags
  savedAnswersWithWarnings: IAnswerWarning[] = [];
  @ViewChild('answerFlagsModal') answerFlagsModal: ElementRef;
  @ViewChild('answerWarningsModal') answerWarningsModal: ElementRef;



  @ViewChild('overrideDropDown') overrideDropDown: ElementRef;
  overRideForm: UntypedFormGroup;
  overRideFlag = '';
  constructor(
    private activatedRoute: ActivatedRoute,
    private taxReturnsResolver: TaxReturnsResolver,
    private taxReturnService: TaxReturnService,
    private answerService: AnswerService,
    private commentService: CommentService,
    private userInfo: UserInfoService,
    private flagService: FlagService,
    private config: ConfigStateService,
    private taxReturnSubcategoryService: TaxReturnSubcategoryService,
    private fb: UntypedFormBuilder,
    private rubixDocumentService: RubixDocumentsService,
    private smartFormService: SmartFormTypeService,
    private runCalcsService: RunCalcsService,
    private translocoService: TranslocoService,
    private attachmentsService: AttachmentsService,
  ) {
  }

  ngDoCheck() {
    if (this.commentFields.length > 0) {
      this.unsaved = true;
    }
    if (this.isAllModalsClosed()) {
      this.navigationPending = false;
    }
  }

  isAllModalsClosed(): boolean {
    if (!this.unsavedModal || !this.saveModal) {
      return true; // if the modals are not yet defined, consider them as closed
    }
    // If either modal is visible, return false
    return !($(this.unsavedModal.nativeElement).is(':visible') || $(this.saveModal.nativeElement).is(':visible'));
  }

  // fetch tax return from resolver
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.inputQuestionId = Number(queryParams.question)
    });

    this.config.loadConfig().subscribe((config) => {
      this.configLoaded = true;
      this.showQuestionId = config.tenant !== Tenant.AU;
      this.showCalcPlanMessage = config.tenant !== Tenant.JPCORP;
      this.modernTable = this.config.featureFlags.displayModernTableAsDefault ||
        this.activatedRoute.snapshot.queryParams.modernTable != null;
      this.uiConfig = new TenantConfigService(config);
      this.translocoService.selectTranslate('manually-entered-answers').subscribe(value => this.manuallyEnteredAnswersPopupText = value);
      this.translocoService.selectTranslate('are-you-sure-you-want-to-clear').subscribe(value => this.areYouSureYouWantToClearText = value);
    });
    this.isAdmin = !!this.userInfo.isAdmin;
    this.isSuperAdmin = !!this.userInfo.isSuperAdmin;
    this.debug = this.userInfo.isAdmin && this.activatedRoute.snapshot.queryParams.debug != null;
    this.debugModeControl.statusChanges.subscribe(newVal => {
      this.debug = this.debugModeControl.value;
      this.applyDebug();
      this.initSubCategory();
    })
    this.comment = this.fb.control({
      message: '',
      attachments: new Map(),
    });
    this.flagsComment = this.fb.control({
      message: '',
      attachments: new Map(),
    });
    this.commentDocumentMetadatas = [];
    this.subscriptions.push(this.comment.valueChanges.subscribe(newVal => {
      // NOTE(mike): Hack workaround to propagate the form control value to every view
      // the form control is bound to. Without this, using a formControl in 2 inputs will
      // not two-way bind. :(
      this.comment.setValue(newVal, { emitEvent: false, emitViewToModelChange: false });

      // also parse doc links
      const urls = findUrls(newVal).map(({ url }) => url);
      handleUrls(urls, this.commentDocumentMetadatas, this.taxReturnService).then((data: PastedDocMetadata[]) =>
        this.commentDocumentMetadatas = data);

    }));

    this.subscriptions.push(this.taxReturnSubcategoryService.flaggedAnsChanged.subscribe(flaggedAns => {
      this.flaggedAns = flaggedAns;
    }));
    this.subscriptions.push(this.taxReturnSubcategoryService.commentFieldsChanged.subscribe(commentFields => {
      this.commentFields = commentFields;
    }));

    this.newGroupFormGroup = new UntypedFormGroup({}); // form for adding a new group
    this.subscriptions.push(this.taxReturnsResolver.getTaxReturnObs().subscribe((taxReturn: any) => {
      this.taxReturn = cloneDeep(taxReturn);
      this.applyDebug();
      this.rubixDocumentService.setTaxReturnForImageUploads(this.taxReturn);

      this.attachmentsService.setRootFolder(this.folders, this.taxReturn.docshareRootFolder);

      // shared function to append ui meta to warnings and comments
      this.getCommentMeta = (c: IComment) => {
        let user;
        let role;
        if (c.commentAudits && c.commentAudits.length && this.taxReturn && this.taxReturn.preparer && this.taxReturn.preparer.find(p => p.id === c.commentAudits[0].userId)) {
          user = this.taxReturn.preparer.find(p => p.id === c.commentAudits[0].userId);
          role = 'Preparer';
        } else if (c.commentAudits && c.commentAudits.length && this.taxReturn && this.taxReturn.reviewer && this.taxReturn.reviewer.find(p => p.id === c.commentAudits[0].userId)) {
          user = this.taxReturn.reviewer.find(p => p.id === c.commentAudits[0].userId);
          role = 'Reviewer';
        } else {
          user = (c.commentAudits && c.commentAudits.length) ? c.commentAudits[0]['user'] : null;
          role = '';
        }

        const author = user ? user.firstName + ' ' + user.lastName : (c.autoDocLink ? 'Auto generated' : 'Unknown User');
        role = role ? role : (c.autoDocLink ? 'System' : 'Unknown role');

        const m = moment(c.createdAt);
        return {
          id: c.id,
          message: c.message,
          parts: c.parts,
          author,
          role,
          date: m.format("MMMM Do YYYY, h:mm:ss a"),
          dateMoment: m,
          isReply: c.parentCommentId,
          externalUrl: c.externalUrl,
          hasSentToClient: c.hasSentToClient,
          replyComment: { message: "", attachments: new Map() },
          replyTo: false,
          attachments: c.attachments,
        };

      };
      this.pushComments = (newComment: IComment) => {
        this.handleCommentReply(newComment);
        const parentC = this.comments.find(_c => _c.id === newComment.parentCommentId);
        parentC.comments.push(this.getCommentMeta(newComment));
      };

      this.initSubCategory();

      if (this.config.featureFlags.enableOneteamIntegration) {
        this.smartFormService.getSmartFormsByTaxReturnId(this.taxReturn.id).subscribe((smartFormList: any) => {
          if (smartFormList?.length) {
            this.smartFormService.getSentSmartFormRequests(this.taxReturn.id).subscribe((smartFormRequest: any) => {
              smartFormList.forEach(sf => {
                if (smartFormRequest.some(r => r.smartFormTypeId === sf.id && r.otRequestId && r.syncDate)) {
                  this.smartForms.push(sf)
                }
              })
              this.visibleQuestions = getVisibleQuestionsInSmartForms(this.smartForms)
            })
          }
        })
      }

    }));
    this.overRideForm = this.fb.group({
      overRide: ['']
    });

    this.subscriptions.push(combineLatest([
          this.runCalcsService.isRunningCalcs,
          this.runCalcsService.calcResultsSummary,
          this.runCalcsService.calcFailures,
          this.runCalcsService.calcDebug,
          this.runCalcsService.showCalcDebug]).subscribe(
          ([isRunning, calcSummary, calcfail, calDebug, showCalDebug]) => {
            this.isRunningCalcs = isRunning,
              this.calcResultsSummary = calcSummary,
              this.calcFailures = calcfail,
              this.calcDebug = calDebug,
              this.showCalcDebug = showCalDebug
          }
     ))
  }

  countInputWarnings(currentAnswerWarning: IAnswerWarning, comment: CommentValue, close: boolean): void {
    this.answerWarningsWithComments = [];
    this.currentAnswerWarning = currentAnswerWarning;
    this.currentAnswerComment = comment;
    this.shouldClose = close;  // Store the 'close' value
    let count = 0;

    if (!currentAnswerWarning) {
      alert('currentAnswerWarning is not defined');
      return;
    }

    // Loop over each 'answerWarning' object
    for (let answerWarning of this.answerWarnings) {
      // Check if 'replyComment' field has a value
      if (answerWarning.replyComment.message) {
        // If an input is waiting, increment the count
        count++;
        // Push the answerWarning into the array as an object with corresponding replyComment
        this.answerWarningsWithComments.push({ answerWarning: answerWarning, comment: answerWarning.replyComment });
      }
    }

    if (count > 1){
      $(this.bulkReplyModal.nativeElement).modal('show');
    } else {
      this.saveAnsWarningReply(this.currentAnswerWarning, this.currentAnswerComment, this.shouldClose);
    }
  }

  handleYesClick() {
    for (let item of this.answerWarningsWithComments) {
      this.saveAnsWarningReply(item.answerWarning, item.comment, this.shouldClose);
    }
  }

  handleNoClick() {
      this.saveAnsWarningReply(this.currentAnswerWarning, this.currentAnswerComment, this.shouldClose);
  }

  ngAfterViewInit() {
    const questionId = this.activatedRoute.params['value']['questionId'];
    if (questionId) {
      let foundSubGroupIdContainer = false;
      let tableAddIconClicked = false;
      interval(1000)
        .pipe(takeWhile(() => !foundSubGroupIdContainer))
        .subscribe(i => {
          // This will be called every 1 seconds until `stopCondition` flag is set to true

          // For table questions it will click on + icon
          if (i > 0 && !tableAddIconClicked) {
            const buttonToClick = 'add-new-table-row';
            if (document.getElementsByClassName(buttonToClick)) {
              tableAddIconClicked = true;
              Array.from(document.getElementsByClassName(buttonToClick)).forEach((item: HTMLElement) => {
                item.click();
              });
            }
          }

          // scroll to particular element
          const divToScroll = 'question-' + questionId;
          if (divToScroll && document.getElementById(divToScroll)) {
            document.getElementById(divToScroll).scrollIntoView();
            document.getElementById('question-input-' + questionId).focus();
            foundSubGroupIdContainer = true;
          }

          // scroll to table  element
          const tableQuetionId = 'question-table-warning-' + questionId;
          if (tableQuetionId && document.getElementById(tableQuetionId)) {
            document.getElementById(tableQuetionId).click();
            document.getElementById(tableQuetionId).scrollIntoView();
            foundSubGroupIdContainer = true;
          }

        });
    }
  }

  ngAfterViewChecked() {
    this.scrollableElements.forEach((elementRef, index) => {
      let scrollPosition = this.scrollPositions.get(index);
      let scrollLeftPosition = this.scrollLeftPositions.get(index);
      if (scrollPosition != null) {
        elementRef.nativeElement.scrollTop = scrollPosition;
      }
      if (scrollLeftPosition != null) {
        elementRef.nativeElement.scrollLeft = scrollLeftPosition;
      }
    });
    this.questionGroupCards.forEach((childComponent: QuestionGroupCardComponent, index) => {
      if (childComponent && childComponent.tableScrollContainer && childComponent.subGroup.isTable) {
        const scrollPosition = this.tableScrollPositions.get(childComponent.subGroup.id);
        const scrollLeftPosition = this.tableScrollLeftPositions.get(childComponent.subGroup.id);
        if (scrollPosition != null) {
          childComponent.tableScrollContainer.nativeElement.scrollTop = scrollPosition;
        }
        if (scrollLeftPosition != null) {
          childComponent.tableScrollContainer.nativeElement.scrollLeft = scrollLeftPosition;
        }
      }
    });
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTop = this.lastScrollPosition;
      this.scrollContainer.nativeElement.scrollLeft = this.lastScrollLeftPosition;
    }
  }

  onScroll(event) {
    this.lastScrollPosition = this.scrollContainer.nativeElement.scrollTop;
  }

  onTableScroll(event: Event, subGroupId: number) {
    if (subGroupId != null) {
    const target = event.target as Element;
      this.tableScrollPositions.set(subGroupId, target.scrollTop);
      this.tableScrollLeftPositions.set(subGroupId, target.scrollLeft);
    } else {
      this.lastScrollPosition = this.scrollContainer.nativeElement.scrollTop;
      this.lastScrollLeftPosition = this.scrollContainer.nativeElement.scrollLeft;
    }
  }

  newRow({subgroupId, rowIndex}) {
    const tblToScroll = 'question-table-tr-' + rowIndex;
    if(tblToScroll && document.getElementById(tblToScroll) ){
      const inputTblTdElement = document.getElementById(tblToScroll);
      if(subgroupId !== null) {
        this.scrollPositions.set(subgroupId, inputTblTdElement.getBoundingClientRect().top);
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subcategorySubs.forEach(s => s.unsubscribe());
    if (this.dependantMandatoryChangedSub) this.dependantMandatoryChangedSub.unsubscribe();
    if (this.activeGroupSub) this.activeGroupSub.unsubscribe();
    this.rubixDocumentService.setTaxReturnForImageUploads(null);
  }

  // fetches full tax return data. this method is only called on save
  getTaxReturn() {
    this.lastActiveGroupId = null;
    this.lastActiveGroupName = null;
    this.lastActiveSubGroupId = null;

    if (this.activeGroup) {
      if (this.activeGroup.id >= 0) {
        this.lastActiveGroupId = this.activeGroup.id;
      } else {
        this.lastActiveGroupName = this.getFormControl(this.activeGroup, this.activeGroup.question).value;
      }
      if (this.activeGroup.activeSubGroup) {
        this.lastActiveSubGroupId = this.activeGroup.activeSubGroup.id;
      }
    }

    const taxReturnId = this.taxReturn.id;
    getFullTaxReturn(this.taxReturnService, taxReturnId, this.subCategory.id)
      .subscribe(taxReturn => {
        this.taxReturn = taxReturn;
        this.applyDebug();
        this.initSubCategory();
        if (this.traceQuestion || this.traceAnswer) {
          this.loadTrace(null);
        }
      });
  }

  setCollapsedState({collapsed, groupId, subGroupId}) {
    if(this.config.featureFlags.rememberCollapsedSubgroups == false)
      return;

    const collapsedSubCategories = JSON.parse(localStorage.getItem(`TR collapsed SG ${this.taxReturn.id}`)) ?? {};
    if (collapsed) {
      if(!collapsedSubCategories[groupId])
        collapsedSubCategories[groupId] = { collapsedSubgroups: {} }
      collapsedSubCategories[groupId].collapsedSubgroups[subGroupId] = true;
    }
    else {
      delete collapsedSubCategories[groupId]?.collapsedSubgroups[subGroupId];
      if (Object.keys(collapsedSubCategories[groupId]?.collapsedSubgroups ?? {}).length === 0) {
        delete collapsedSubCategories[groupId];
      }
    }
    localStorage.setItem(`TR collapsed SG ${this.taxReturn.id}`, JSON.stringify(collapsedSubCategories))
    this.getCollapsedStates(collapsedSubCategories);
  }

  getCollapsedStates(collapsedSubCategories = null) {
    if (this.config.featureFlags.rememberCollapsedSubgroups)
      collapsedSubCategories ??= JSON.parse(localStorage.getItem(`TR collapsed SG ${this.taxReturn.id}`)) ?? {};
    else
      collapsedSubCategories = {}

    this.subCategory.groups.forEach(sC => {
      sC.subgroups?.forEach(sG => {
        sG.isCollapsed = collapsedSubCategories[sC.id]?.collapsedSubgroups[sG.id] ?? false;
      })
    })
  }

  initSubCategory() {
    this.subcategorySubs.forEach(s => s.unsubscribe());
    this.subcategorySubs.length = 0;
    if (this.dependantMandatoryChangedSub) {
      this.dependantMandatoryChangedSub.unsubscribe();
      this.dependantMandatoryChangedSub = null;
    }
    this.comment.patchValue({
      message: '',
      attachments: new Map(),
    });

    this.taxReturnSubcategoryService.setCommentFields([]);
    this.commentDocumentMetadatas = [];

    this.isReady = false;
    this.subCategory = this.getOriginalSubcategory();
    if (!this.subCategory) {
      this.subcatsInitated = false;
      return;
    }
    this.subCategory.questions.forEach(q => {
      this.questionsById[q.id] = q
    })
    this.warningCount = this.subCategory.warningCount;
    this.getCollapsedStates();
    this.initGroupQuestions();
    this.initGroups();
    this.initForms();
    this.initFlags();
    this.initComments();
    this.initReviews();
    this.initOverrideDropDown();

    this.commentsCount = 0;
    for(const comment of this.comments) {
      const numberOfReplies = comment.comments?.length;
      this.commentsCount += 1 + numberOfReplies;
    }
    this.isSaving = false;
    this.unsaved = false;

    // Now initialize the selected group
    const group = this.subCategory.groups.find(g => g.id === this.lastActiveGroupId || g.name === this.lastActiveGroupName);
    if (group) {
      const index = this.subCategory.groups.indexOf(group);
      this.gotoGroup(index >= 0 ? index : 0);
      group.activeSubGroup = group.subgroups.find(sg => sg.id === this.lastActiveSubGroupId);
    } else {
      this.gotoGroup(0);
    }

    this.resolveDocuments();
    this.subcatsInitated = true;
  }

  initNewGroupTemplate() {
    // Setup add group formControl
    const templateGroupQuestion: IFormField = {
      ...cloneDeep(this.groupQuestion),
      answers: [],
    };
    this.newGroupFormGroup.addControl(String(templateGroupQuestion.id), makeControlForQuestion(templateGroupQuestion));

    // Template for creating new groups
    this.newGroupTemplate = cloneDeep(this.subCategory.groups[0]);
  }

  // gets the specific subcategory from the tax return
  getOriginalSubcategory() {
    const subCategoryId = Number(this.activatedRoute.params['value']['subCategoryId']);
    let subCategory = null;
    this.taxReturn.categories.forEach(c => {
      c.subcategories.forEach(sc => {
        if (sc.id === subCategoryId) {
          subCategory = sc;
          subCategory.isGlobal = c.taxReturnTypeId === null ? true : false;
          this.categoryName = c.name;
        }
      });
    });
    return cloneDeep(subCategory);
  }

  /**
   * If the subcategory has an isTab question, then setup the group.question for later convenience.
   */
  initGroups() {
    this.hasGroupings = !!this.groupQuestion;
    if (this.hasGroupings) {
      // For each group set group.question to be the group question filtered down to the single answer for that group.
      // When it is just a single group with id=0 then there is no answer.
      this.subCategory.groups.forEach(group => {
        group.question = {
          ...cloneDeep(this.groupQuestion),
          answers: group.id === 0 ? [] : this.groupQuestion.answers.filter(answer => answer.id === group.id),
          default: group.id === 0 ? this.defaultGroupName : this.groupQuestion.default,
        };

        if (group.deleted) {
          // assign the previous answer
          let deletedName = '';
          group.question.answers.forEach(a => {
            // @ts-ignore Fix types. usage of any type for subcategory results in cascading type errors
            const newestAudit = maxBy(a.answerAudits, aa => aa.id);
            // @ts-ignore Fix types. usage of any type for subcategory results in cascading type errors
            deletedName = newestAudit ? newestAudit.oldAnswer : "";
            a.answer = deletedName;
          });
          group.deletedName = deletedName || 'deleted';
        }
      });

      this.initNewGroupTemplate();
    }

    this.isReady = true;
    this.firstLoad = false;
  }



  // create a form for each subgroup in group
  // this is needed to allow each form wrapper to apply the same question ids for form controls
  // because a subgroup can contain the same question id
  // for tab question, will need to create its own form since the tab question doesn't belong to a subgroup
  initForms(groupId?: number) {
    this.subCategory.groups.forEach((group) => {
      if (groupId == null || group.id === groupId) {
        group.formGroup = this.buildFormForGroup(group);
        group.uiControls = new UntypedFormGroup({
          'hideEmptyQuestions': new UntypedFormControl(false)
        });
        if (group.deleted) {
          group.deletedFormGroup = this.buildFormForGroup(group, true);
        }
      }
    });

    this.subCategory.groups.forEach((group) => {
      if (groupId == null || group.id === groupId) {
        this.detectFormChanges(group);
      }
    });

    this.dependantMandatoryChangedSub = this.dependantMandatoryChanged.subscribe();
  }

  initGroupQuestions() {
    const questionsById = {};
    this.taxReturn.questions.forEach(q => questionsById[q.id] = q);

    const subcategoryGroupQuestion = this.subCategory.questions.find(q => questionsById[q.id].isTab);
    this.groupQuestion = cloneDeep(questionsById[subcategoryGroupQuestion && subcategoryGroupQuestion.id]);

    // group questions
    this.subCategory.groups.forEach(group => {
      // subgroup questions
      group.subgroups.forEach(subgroup => {
        subgroup.questions = subgroup.questions.map(q => {
          const answersById = {};
          q.answers.forEach(a => answersById[a.id] = a);
          const answers = q.answers.map(a => answersById[a.id]);
          if (group.deleted) {
            answers.forEach(a => {
              // @ts-ignore TODO fix types
              const prevAnswer = maxBy(a.answerAudits, aa => aa.id);
              if (prevAnswer) {
                // @ts-ignore TODO fix types
                a.answer = prevAnswer.oldAnswer;
              }
            });
          }
          return {
            ...q,
            answers,
            default: q.isTab && group.id === 0 ? this.defaultGroupName : q.default,
          };
        });
        subgroup.hidden = subgroup.questions.every(q => q.hidden) || (subgroup.isTable && subgroup.question.hidden);
      });
    });

  }

  initOverrideDropDown() {

    setTimeout(() => {
      this.overrideDropDown = $(this.overrideDropDown?.nativeElement).dropdown({
        values: [{
          value: "CLEAR SUBCATEGORY",
          name: "CLEAR SUBCATEGORY",
          selected: this.overRideFlag === "CLEAR SUBCATEGORY"
        },
        {
          value: "SINGLE ANSWER",
          name: "SINGLE ANSWER",
          selected: this.overRideFlag === "SINGLE ANSWER"
        }
        ],
        placeholder: "CLEAR OVERRIDES",
        fullTextSearch: "exact",
        preserveHTML: false,
        direction: 'downward',
        onChange: (value: string, text: string, choice: any) => {
          if (choice.disabled) {
            return false;
          }
          this.overRideFlag = value
          this.updateOverRideFlag();
        }
      });
    });

  };


  handleAnswerChange(group: IGroup, control, question, newVal, subgroup, rowIndex?: number) {
    // NOTE(mike): Hack workaround to propagate the form control value to every view
    // the form control is bound to. Without this, using a formControl in 2 inputs will
    // not two-way bind. :(
    if (group.question && question.id === group.question.id) control.setValue(newVal, {
      emitEvent: false,
      emitViewToModelChange: false
    });

    newVal = newVal == null ? "" : String(newVal);

    question.groupId = group.id;
    if (!subgroup) {
      const groupName = group.deleted ? group.deletedName : newVal;
      question.groupName = groupName;
      // update group name for every subgroup question
      group.subgroups.forEach(sg => sg.questions.forEach((q: any) => q.groupName = groupName));
    }
    if (subgroup) {
      question.subGroupId = subgroup.id;
      question.subGroupName = subgroup.name;
    }

    const answer = rowIndex != null ? subgroup.rows[rowIndex].cells[question.id] : (question.answers.length > 0 ? question.answers[0] : null);
    const originalAnswer = answer && !answer.isNew && answer.answer != null ? answer.answer : '';
    let valueHasChangedFromOriginal = newVal !== originalAnswer;

    if (question.displayFieldType === 'checkbox' && question.answers.length === 0 && question.default === "true") {
      valueHasChangedFromOriginal = true;
    }

    const commentField = cloneDeep(question);
    commentField.answerChanged = valueHasChangedFromOriginal;
    commentField.rowIndex = rowIndex;

    // remove from array if val is same as previous
    if (!valueHasChangedFromOriginal) {
      const qInArr = this.commentFields.find(cf => commentFieldsMatch(cf, commentField));
      // Remove when the commentField was due to an answer change
      if (qInArr && qInArr.answerChanged) {
        this.taxReturnSubcategoryService.removeCommentField(qInArr);
      }
    } else {
      const qInArr = this.commentFields.find(cf => commentFieldsMatch(cf, commentField));
      if (qInArr) {
        // Edit when the commentField was not due to an answer change, but now is

        const updatedCommentFields = this.commentFields.map(cf => cf === qInArr ? { ...qInArr, answerChanged: true } : cf);
        this.taxReturnSubcategoryService.setCommentFields(updatedCommentFields);
      } else {
        // Just add it
        if (rowIndex != null) {
          if (!this.readonly()) {
            this.taxReturnSubcategoryService.addCommentField(commentField);
          }
        } else {
          const groupQuestionDuplicated = !subgroup && group.subgroups.some(sg => sg.questions.some(q => q.id === question.id));
          if (!this.readonly() && (subgroup || !groupQuestionDuplicated)) {
            this.taxReturnSubcategoryService.addCommentField(commentField);
          }
        }
      }
    }
  }

  // watch form changes and auto append field label to edit comment
  // if subcategory has groupings, a formgroup ia appended to each group because the group question does not belong to a subgroup
  // a form group is appended to each sub group
  // allow time for form wrapper to add control to formgroup
  detectFormChanges(group: IGroup) {

    // Handle tab answer changes
    if (group.question) {
      const control = group.formGroup.controls[group.question.id];
      const sub = control.valueChanges.subscribe(newVal => this.handleAnswerChange(group, control, group.question, newVal, null));
      this.subcategorySubs.push(sub);
      this.handleAnswerChange(group, control, group.question, control.value, null);
    }

    // Handle subgroup answer changes
    group.subgroups.forEach(sg => {
      if (!sg.isTable) {
        sg.questions.forEach(sgq => {
          const control = this.getFormControl(group, sgq);
          const sub = control.valueChanges.subscribe(newVal => this.handleAnswerChange(group, control, sgq, newVal, sg));
          this.subcategorySubs.push(sub);
          this.handleAnswerChange(group, control, sgq, control.value, sg);
        });
      }
    });
  }

  // reload view with group data and reset activated sub group
  gotoGroup(index: number) {
    const nextGroup = this.subCategory.groups[index];
    if (nextGroup !== this.activeGroup) {
      this.activeGroup = nextGroup;
      this.activeGroupsSelected[this.activeGroup.id] = this.activeGroup;
      if (this.activeGroupSub) this.activeGroupSub.unsubscribe();
      this.deselectCard(index);
      this.onSubgroupChange();
      setTimeout(() => $('.ui.checkbox').checkbox());
    }
  }

  onSubgroupChange() {
    this.initWarnings();
    this.filterFlags();
    this.filterDocuments();
    this.initReviews();
  }

  // show modal to create new group
  showAddGroupModal() {
    if (this.groupQuestion) {
      el(this.addGroupModal).modal({
        onShow: () => {
          // re-init answer when closing modal without saving
          this.newGroupFormGroup.controls[this.groupQuestion.id].setValue(this.groupQuestion.default || "");
        },
        onApprove: () => {
          this.addGroup();
        },
      }).modal('show');
    }
  }

  nextGroupId() {
    const id = this.newGroupId;
    // keep going negative, not to overlap with real groups
    this.newGroupId -= 1;
    return id;
  }

  // adds new group to tabs menu then goes to newly created group
  // do not append the 'parentAnswerId' when creating a new group
  addGroup() {
    const groupName = this.newGroupFormGroup.controls[this.groupQuestion.id].value;
    const groupId = this.nextGroupId();
    // clone the group template so we can reuse the subgroup structure, then clean out the Qs and As
    const groupClone = cloneDeep(this.newGroupTemplate);
    const newGroupQuestion = { ...this.groupQuestion, answers: [], default: groupName };
    const newGroup = {
      id: groupId,
      name: groupName,
      question: newGroupQuestion,
      subgroups: groupClone.subgroups.map(sg => ({
        ...sg,
        questions: sg.questions.map(q => ({
          ...q,
          answers: [],
          default: q.id === newGroupQuestion.id ? newGroupQuestion.default : q.default,
        })),
        ...(sg.isTable ? { rows: [], question: { ...sg.question, answers: [] } } : {}),
      })),
    };
    this.subCategory.groups.push(newGroup);

    // this will get re-subbed in initForms()
    if (this.dependantMandatoryChangedSub) {
      this.dependantMandatoryChangedSub.unsubscribe();
    }
    this.initForms(groupId);

    this.gotoGroup(this.subCategory.groups.length - 1);
  }

  // allow time for form wrapper to add control to formgroup
  showDeleteGroupModal(group: IGroup) {
    this.groupToDelete = group;
    el(this.deleteGroupModal).modal({
      onApprove: () => {
        this.deleteGroup(group);
      },
    }).modal("show");
  }

  // deletes a group by updating all answers for group with empty ''
  deleteGroup(group: IGroup) {
    if (group.id <= 0) {
      const activeGroupIndex = this.subCategory.groups.indexOf(this.activeGroup);
      const groupIndex = this.subCategory.groups.indexOf(group);
      this.subCategory.groups.splice(groupIndex, 1);
      this.taxReturnSubcategoryService.removeCommentFieldsByGroup(group.id);

      const newGroupIndex = Math.min(activeGroupIndex, this.subCategory.groups.length - 1);
      this.gotoGroup(newGroupIndex);
    } else {
      const control = group.formGroup.controls[group.question.id];
      group.deleted = true;
      group.deletedName = control.value;
      group.deletedFormGroup = this.buildFormForGroup(group, true);

      const clearControl = c => {
        if (c.value != null || c.value !== "") {
          c.setValue('');
          c.markAsDirty();
        }
      };

      clearControl(control);

      group.subgroups.forEach(sg => sg.questions.forEach(q => {
        if (sg.isTable) {
          sg.rows.forEach((row, i) => {
            const c = this.getFormControl(group, q, i);
            clearControl(c);
          });
        } else {
          if (!q.isRowId) {
            const c = this.getFormControl(group, q);
            clearControl(c);
          }
        }
      }));
    }
  }


  // deselects an active sub group on container background click
  deselectCard(groupIndex: number) {
    delete this.subCategory.groups[groupIndex].activeSubGroup;
    this.onSubgroupChange();
  }

  selectSubgroup(subGroup) {
    if (!this.activeGroup.activeSubGroup || subGroup.id !== this.activeGroup.activeSubGroup.id) {
      this.activeGroup.activeSubGroup = subGroup;
      this.onSubgroupChange();
    }
  }

  getTaxReturnIdForCategory() {
    if (this.subCategory.isGlobal && this.taxReturn.globalTaxReturnId) {
      return this.taxReturn.globalTaxReturnId;
    }
    return this.taxReturn.id;
  }

  // saves all answers for group tab and subgroups then saves comments which is required
  // only saves answers which have changed
  async save(isCommentBox?: boolean) {
    this.isSaving = true;

    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subCategory.name, Array.from(this.comment.value.attachments.values()));
    if (!success) {
      this.isSaving = false;
      return;
    };

    // # TODO
    const comment: ICommentWithAnswersTree = {
      taxReturnId: this.getTaxReturnIdForCategory(),
      comment: {
        message: this.comment.value.message,
        attachments,
      },
      answers: [],
      forceAnswerIds: [],
    };

    this.subCategory.groups.forEach((group, i) => {
      const commentFields = this.commentFields.filter(cf => !cf.answerChanged && cf.groupId === group.id);
      if (group.question) {
        const questionId = group.question.id;
        const formControl = group.formGroup.controls[questionId];
        const existingAnswer = group.id > 0 ? group.question.answers.find(a => a.id === group.id) : null;
        const originalAnswerValue = existingAnswer && existingAnswer.answer != null ? existingAnswer.answer : '';
        const formControlValue = formControl.value != null ? String(formControl.value) : '';
        const valueChanged = !group.deleted && originalAnswerValue !== formControlValue;

        // Need to handle the case of comments without changing an answer
        const targetCf = { id: group.question.id, groupId: group.id };
        const isCommentOnly = !valueChanged && commentFields.some(cf => commentFieldsMatch(cf, targetCf));

        const answer: ICommentAnswerRequestNode = {
          questionId: group.question.id,
          answer: group.deleted ? "" : formControlValue,
          answers: [],
          _saveIfEmpty: valueChanged,
          overrideStatus: valueChanged ? 2 : 0, // manually created tabs have overrideStatus=2
        };

        if (existingAnswer) {
          answer.id = existingAnswer.id;
          if (isCommentOnly) {
            comment.forceAnswerIds.push(answer.id);
            answer.overrideStatus = existingAnswer.overrideStatus;
          } else {
            answer.overrideStatus = existingAnswer.overrideStatus || 1; // 2 if it was 2, otherwise 1 if it was 0
          }
        } else {
          // find the manual row id and set it
          const rowIdQ = this.subCategory.questions.find(q => q.isRowId && q.parentId == null);
          if (rowIdQ && !group.deleted) {
            answer.answers.push({
              questionId: rowIdQ.id,
              answer: `manual-${rowIdQ.id}-${crypto.randomUUID()}`,
              overrideStatus: 1,
            });
          }
        }
        comment.answers.push(answer);
      }

      Object.keys(group.formGroup.controls).forEach(key => {

        // don't save the group question more than once
        if (group.question && group.question.id === Number(key)) return undefined;

        let questionId;
        let rowIndex: number;
        let formControl;
        let q: IFormField;

        // table row questions have id format of tableQuestionId-questionId (eg 123-2). extract the table question id
        if (key.indexOf("-") !== -1) {
          questionId = Number(key.substr(0, key.indexOf("-"))); // table question id
          rowIndex = Number(key.substr(key.indexOf("-") + 1));
        } else {
          questionId = Number(key);
        }

        group.subgroups.forEach(sg =>
          sg.questions.forEach(_q => {
            if (_q.id === questionId) q = _q;
          })
        );

        if (rowIndex != null) {
          formControl = this.getFormControl(group, q, rowIndex);
          const sg = group.subgroups.find(sg => sg.isTable && q.parentId === sg.question.id);

          // find the existing answer from the subgroups
          const row = sg.rows[rowIndex];
          const existingAnswer = row.cells[q.id];
          const originalAnswerValue = existingAnswer && existingAnswer.answer != null ? existingAnswer.answer : '';
          const formControlValue = formControl.value != null ? String(formControl.value) : '';
          const valueChanged = !group.deleted && originalAnswerValue !== formControlValue;

          // Need to handle the case of comments without changing an answer
          const targetCf = { id: q.id, groupId: group.id, rowIndex };
          const isCommentOnly = !valueChanged && commentFields.some(cf => commentFieldsMatch(cf, targetCf));

          if (valueChanged || isCommentOnly) {

            // prepare cell answer
            const answer: ICommentAnswerRequestNode = {
              questionId: q.id,
              answer: group.deleted ? "" : formControlValue,
              overrideStatus: isCommentOnly ? 0 : 1, // modifying any table cell in the UI is an override with status=1
            };

            if (existingAnswer && !existingAnswer.isNew) answer.id = existingAnswer.id;

            if (isCommentOnly && answer.id != null) {
              comment.forceAnswerIds.push(answer.id);
            } else {
              const rowIdQ = this.subCategory.questions.find(qq => qq.isRowId && qq.parentId === q.parentId);
              const makeManualRowId = () => `manual-${rowIdQ.id}-${crypto.randomUUID()}`;
              // init row answer, if it doesn't already exist
              const answersArr: any = group.question ? comment.answers[i].answers : comment.answers;
              let rowAnswerNode = answersArr.find(a => a.questionId === q.parentId && a._rowIndex === rowIndex);
              if (!rowAnswerNode) {
                const rowAns: ICommentAnswerRequestNode = {
                  questionId: q.parentId,
                  answer: "", // table ans should always be empty
                  answers: [],
                  overrideStatus: group.deleted ? 0 : 1, // adding new rows is overrideStatus=1
                  _rowIndex: rowIndex,
                };

                // if we're making changes and the rowId is empty, change it to a manual row override (including setting the rowId Q)
                const rowIdAnswer = rowIdQ ? row.cells[rowIdQ.id] : null;
                const updateRowIdQ = !group.deleted && (!row.rowAnswer || (valueChanged && rowIdAnswer && !rowIdAnswer.answer));

                if (row.rowAnswer) {
                  rowAns.id = row.rowAnswer.id;
                  // maintain the original override status for row answers, except if we're updating the rowIdQ
                  rowAns.overrideStatus = updateRowIdQ ? 1 : row.rowAnswer.overrideStatus;
                }
                if (updateRowIdQ) {
                  const a: any = {
                    questionId: rowIdQ.id,
                    answer: makeManualRowId(),
                    overrideStatus: 1,
                  };
                  if (rowIdAnswer && rowIdAnswer.id != null) {
                    a.id = rowIdAnswer.id;
                  }
                  rowAns.answers.push(a);
                }
                answersArr.push(rowAns);

                rowAnswerNode = rowAns;
              }
              rowAnswerNode.answers.push(answer);
            }
          }
        } else {
          formControl = group.formGroup.controls[questionId];

          // find the existing answer from the subgroups
          let existingAnswer = null;

          group.subgroups.forEach(sg => sg.questions.forEach(q => {
            if (q.id === questionId && q.answers.length > 0) existingAnswer = q.answers[0];
          }));

          const originalAnswerValue = existingAnswer && existingAnswer.answer != null ? existingAnswer.answer : '';
          const formControlValue = formControl.value != null ? String(formControl.value) : '';
          const valueChanged = originalAnswerValue !== formControlValue;

          // Need to handle the case of comments without changing an answer
          const targetCf = { id: q.id, groupId: group.id, rowIndex };
          const isCommentOnly = !valueChanged && commentFields.some(cf => commentFieldsMatch(cf, targetCf));

          if (valueChanged || isCommentOnly) {

            const answer: ICommentAnswerRequestNode = {
              questionId: questionId,
              answer: group.deleted ? "" : formControlValue,
              overrideStatus: isCommentOnly ? 0 : 1, // modifying any non-row/non-tab field in the UI is an override with status=1
            };

            if (existingAnswer) answer.id = existingAnswer.id;

            if (isCommentOnly && answer.id != null) {
              comment.forceAnswerIds.push(answer.id);
            } else if (group.question) {
              comment.answers[i].answers.push(answer);
            } else {
              comment.answers.push(answer);
            }
          }
        }
      });
    });
    // strip out modifications to tab questions where there are no changes
    comment.answers = comment.answers.filter(a => a._saveIfEmpty === undefined || a._saveIfEmpty || a.answers.length > 0);

    // prompt to close any active answer warnings or flags
    const ansWarningAndFlagSubs = [];
    const checkAnsWarningsAndFlags = () => {
      this.savedAnswersWithFlags = [];
      this.savedAnswersWithWarnings = [];

      const pushWarningAndFlagAns = (answer: IAnswer) => {
        const ansWarnings: IAnswerWarning[] = this.answerWarnings.filter(aF => aF.answerId === answer.id && aF.status === 0);
        this.savedAnswersWithWarnings.push(...ansWarnings);
        const ansFlags: IAnswerFlag[] = this.answerFlags.filter(aF => aF.answerId === answer.id && aF.status === 0);
        this.savedAnswersWithFlags.push(...ansFlags);
      };

      const collectWarningsAndFlags = a => {
        if (a.id) {
          pushWarningAndFlagAns(a);
        }
        if (a.answers) {
          a.answers.forEach(aa => collectWarningsAndFlags(aa));
        }
      };

      comment.answers.forEach(a => collectWarningsAndFlags(a));

      const showAnsFlagsModal = () => {
        if (this.savedAnswersWithFlags.length > 0) {
          el(this.answerFlagsModal).modal({
            closable: false,
            onApprove: () => {
              this.savedAnswersWithFlags.forEach(aF => {
                const _comment: any = {
                  parentCommentId: aF.parentComment.id,
                  message: this.comment.value.message,
                  attachments,
                  answerIds: [aF.answerId]
                };
                ansWarningAndFlagSubs.push(this.commentService.addComment(_comment));
              });

              ansWarningAndFlagSubs.push(this.answerService.updateAnswerFlag({
                answerFlagIds: this.savedAnswersWithFlags.map(aF => aF.id),
                status: 99
              }));

              handleAnsWarningAndFlagSubs();
            },
            onDeny: () => {
              handleAnsWarningAndFlagSubs();
            }
          }).modal("show");

        } else {
          handleAnsWarningAndFlagSubs();
        }
      };

      const showAnsWarningsModal = () => {
        if (this.savedAnswersWithWarnings.length > 0) {
          el(this.answerWarningsModal).modal({
            closable: false,
            onApprove: () => {
              this.savedAnswersWithWarnings.forEach(aW => {
                const comment: any = {
                  message: this.comment.value.message,
                  attachments,
                  answerIds: [aW.answerId],
                  answerWarningId: aW.id,
                };
                ansWarningAndFlagSubs.push(this.commentService.addComment(comment));
              });
              ansWarningAndFlagSubs.push(this.answerService.updateAnswerWarning({
                answerWarningIds: this.savedAnswersWithWarnings.map(aW => aW.id),
                status: 1
              }));
              showAnsFlagsModal();
            },
            onDeny: () => {
              showAnsFlagsModal();
            }
          }).modal("show");
        } else {
          showAnsFlagsModal();
        }
      };
      showAnsWarningsModal();
    };


    const handleAnsWarningAndFlagSubs = () => {

      if (ansWarningAndFlagSubs.length > 0) {

        // save sequentially as BE can't handle multiple async requests on comment route
        let length = 0;
        const sub = () => {
          ansWarningAndFlagSubs[length].subscribe(() => {
            length = length + 1;
            if (length < ansWarningAndFlagSubs.length)
              sub();
            else
              handlePostSave();
          }, () => this.isReady = false);
        };
        sub();

      } else {
        handlePostSave();
      }

    };

    // after handling ans warnings and flags
    const handlePostSave = () => {
      this.getTaxReturn();
      this.comment.patchValue({
        message: '',
        attachments: new Map(),
      });
      this.commentDocumentMetadatas = [];
      this.isSaving = false;
      this.unsaved = false;

      if (isCommentBox) {
        this.isReady = false;
      } else {
        el(this.saveModal).modal({
          onHidden: () => {
            this.isReady = true;
          }
        }).modal('hide');
      }

      // clear the flag because they are no longer relevant to the new answer
      this.taxReturnSubcategoryService.setFlaggedAns(null);
      this.flagTypeId = 0;
      this.flagsComment.patchValue({
        message: '',
        attachments: new Map(),
      });
    };

    this.commentService.addCommentWithAnswers(comment).subscribe(() => {
      checkAnsWarningsAndFlags();
    }, () => {
      // failed to add comment
      this.isSaving = false;
      this.unsaved = false;
    });
  }

  // checks whether edited fields have comments saved
  // comments are required when editing fields
  saveCheckEdits() {
    if (this.commentFields.length > 0 && !this.comment.value.message) {
      el(this.saveModal).modal({
        onHidden: () => {
        }
      }).modal('show');
    } else if (this.comment.value.message) {
      this.save();
    }
  }

  syncAps() {
    this.isSyncingAps = true;
    this.taxReturnService.syncAndRecalcTaxReturn(this.taxReturn.id).subscribe(result => {
      this.isSyncingAps = false;
      if (result.success) {
        this.isReady = false;
        this.getTaxReturn();
      } else {
        alert("Failed to sync to APS");
      }
    }, e => {
      this.isSyncingAps = false;
    });
  }

  runCalcs() {
    this.runCalcsService.runCalcs(this.taxReturn.id, this.calcResultsModal, this.isAdmin, this.getTaxReturn.bind(this));
  }


  clearCalcsResults() {
    this.runCalcsService.clearCalcsResults();
  }

  toggleCalcDebug() {
    this.runCalcsService.toggleCalcDebug();
  }

  clearOverrides() {

    let flag = false;
    let flagLockedQuestion = false;
    const answerIds: Set<number> = new Set();

    this.subCategory.groups.forEach(g => {
      g.subgroups.forEach(sg => {
        if (sg.question) { // table rows
          const isFileQuestionAsSource = sg.question.displayFieldType === "file" && sg.question.sourceId;
          sg.question.answers.forEach(a => {
            if (isFileQuestionAsSource && !a.answer) {
              answerIds.add(a.id);
            } else {
              // don't clear table answer unless super admin, will clear any hard lock columns
              if(sg.question.lockType !== "hardLock" && sg.question.dataType !== "table"){
                answerIds.add(a.id);
              } else if (this.isSuperAdmin) {
                answerIds.add(a.id);
              }
            }
            if (sg.question.lockType !== 'manualInput' && a.overrideStatus === 1) {
              flagLockedQuestion = true;
            }
          });
        }
        sg.questions.forEach(q => {
          const isFileQuestionAsSource = q.displayFieldType === "file" && q.sourceId;
          q.answers.forEach(a => {
            if (isFileQuestionAsSource && !a.answer) {
              answerIds.add(a.id);
            } else {
              if(q.lockType !== "hardLock"){
                answerIds.add(a.id);
              } else if (this.isSuperAdmin) {
                answerIds.add(a.id);
              }
            }
            if (q.lockType !== 'manualInput' && a.overrideStatus === 1) {
              flagLockedQuestion = true;
            }
          });
        });
      });
    });

    if (answerIds.size > 0 && flagLockedQuestion) {
      this.clearOverrideModalMessage = this.manuallyEnteredAnswersPopupText;
    } else {
      this.clearOverrideModalMessage = this.areYouSureYouWantToClearText;
    }

    el(this.clearOverridesModal).modal({
      onHide: () => {
      },
      onApprove: () => {
        this.isClearingOverrides = true;
        this.taxReturnService.clearOverridesForTaxReturn(this.getTaxReturnIdForCategory(), { answerIds: Array.from(answerIds), updateAnswerFlag: true }).subscribe(result => {
          //this.isClearingOverrides = false;
          if (result.numUpdated) {
            this.clearOverrideModalMessage = `Updated ${result.numUpdated} answer${result.numUpdated === 1 ? '' : 's'}`;
            flag = true;
          } else {
            this.clearOverrideModalMessage = "No answers updated";
          }
        }, e => {
          this.isClearingOverrides = false;
        });
        return false;
      },
      onDeny: () => {
        if (flag) {
          this.isClearingOverrides = false;
          flag = false;
          this.runCalcs();
        } else {
          this.overRideFlag = '';
          this.overRideForm.controls['overRide'].patchValue('');
        }
      }
    }).modal('show');
  }

  showSingleAnswerOverRideModal() {
    const dontShowModal = sessionStorage.getItem('DONT_SHOW_SINGLE_ANSWER_OVERRIDE_MODAL') === 'true';
    if (!dontShowModal) {
      const elem = el(this.singleAnswerOverRideModal);
      elem.modal('show');
    }
  }

  toggleSingleAnswerModalOpenState(event: any) {
    sessionStorage.setItem("DONT_SHOW_SINGLE_ANSWER_OVERRIDE_MODAL", event.target.checked);
  }

  // opens modal with group name edit form
  // allow time for form wrapper to add control to form group
  showEditGroupName(group: IGroup) {
    let hasApproved = false;
    const oldVal = group.formGroup.controls[group.question.id].value;

    el(this.editGroupModal).modal({
      onHide: () => {
        if (!hasApproved) group.formGroup.controls[group.question.id].setValue(oldVal);
      },
      onApprove: () => {
        hasApproved = true;
      }
    }).modal("show");
  }

  // saves all answers then saves comment
  saveComment() {
    this.save(true);
  }

  updateCommentsCount() {
    this.commentsCount += 1;
  }

  updateGroupCommentsCount(count: number) {
    this.totalComments = count;
  }

  // NOTE(Brad) we need to build this without tables as they create a massive performance issue
  // we need to add form controls to the form group in real time on the FE rather than precomputing the form
  buildFormForGroup(group: IGroup, deleted: boolean = false) {
    const formGroup = new UntypedFormGroup({});
    const nonTableQuestions = [];
    const seenQuestionIds = new Set();
    if (group.question) {
      nonTableQuestions.push(group.question);
      seenQuestionIds.add(group.question.id);
    }

    group.subgroups.forEach(sg => {
      if (sg.isTable && !seenQuestionIds.has(sg.question.id)) {
        seenQuestionIds.add(sg.question.id);
        const colQuestions = sg.questions;
        colQuestions.forEach(colQ => {
          if (!seenQuestionIds.has(colQ.id)) {
            seenQuestionIds.add(colQ.id);
            // sg.rows.forEach((row, rowIndex) => {
            //   const cellAnswer = row.cells[colQ.id];
            //   const control = makeControlForQuestion(colQ, true, cellAnswer);
            //   formGroup.addControl(`${colQ.id}-${rowIndex}`, control);
            //   if (control.dirty && !formGroup.dirty) formGroup.markAsDirty();
            // });
          }
        });
      }
    });
    group.subgroups.forEach(sg => {
      sg.questions.forEach(q => {
        if (!seenQuestionIds.has(q.id)) {
          nonTableQuestions.push(q);
          seenQuestionIds.add(q.id);
        }
      });
    });

    nonTableQuestions.forEach(q => {
      const control = makeControlForQuestion(q);
      formGroup.addControl(q.id, control);
      if (control.dirty && !formGroup.dirty) formGroup.markAsDirty();
    });
    const subscriptions = setupDependantMandatory(group, nonTableQuestions, formGroup,
      this.taxReturn.questionsById, deleted ? null : this.dependantMandatoryChanged);
    for (const s of subscriptions) {
      this.subcategorySubs.push(s);
    }

    return formGroup;
  }

  readonly() {
    let alwaysEditableQuestionsLength = 0;

    if (this.activeGroup && this.activeGroup.activeSubGroup) {
      const activeSg = this.activeGroup.activeSubGroup;
      if (activeSg && activeSg.isTable && activeSg.activeRow != null) {
        // init warnings for every column in the active row
        alwaysEditableQuestionsLength = (activeSg.questions && activeSg.questions.length) ? activeSg.questions.filter(q => q.alwaysEditable === true).length : alwaysEditableQuestionsLength;
      } else {
        alwaysEditableQuestionsLength = (activeSg.questions && activeSg.questions.length) ? activeSg.questions.filter(q => q.alwaysEditable === true).length : alwaysEditableQuestionsLength;
      }
    } else if (this.activeGroup && this.activeGroup.subgroups && this.activeGroup.subgroups.length) {
      this.activeGroup.subgroups.forEach(sg => {
        alwaysEditableQuestionsLength = (sg && sg.questions && sg.questions.length) ? sg.questions.filter(q => q.alwaysEditable === true).length : alwaysEditableQuestionsLength;
      });
    }

    const questionsEditable = (alwaysEditableQuestionsLength && alwaysEditableQuestionsLength > 0) ? true : false;
    return (!this.taxReturn
      || this.taxReturn.snapshotId != null
      || !this.taxReturn.assignedUser
      || this.taxReturn.assignedUser.id !== this.userInfo.id
      || this.taxReturn.assignee.status === 99
      || this.taxReturn.userIsReadOnly
      || this.taxReturn.fullStatus.readOnly) && !questionsEditable;

  }
  readonlyAlwaysEditableQuestion() {
    return (!this.taxReturn
      || this.taxReturn.snapshotId != null
      || !this.taxReturn.assignedUser
      || this.taxReturn.assignedUser.id !== this.userInfo.id
      || this.taxReturn.assignee.status === 99
      || this.taxReturn.userIsReadOnly
      || this.taxReturn.fullStatus.readOnly);
  }

  numUndeletedGroups() {
    return this.subCategory && this.subCategory.groups.filter(g => !g.deleted).length;
  }

  allowEditGroupName(group: IGroup) {
    return !this.readonly() && !group.deleted;
  }

  allowDeleteGroup(group: IGroup) {
    // cannot delete when there is exactly one unsaved-group
    const groups = this.subCategory && this.subCategory.groups || [];
    return !this.readonly() && !group.deleted && !(groups.length === 1 && group.id <= 0);
  }

  // gets the form control
  getFormControl: Function = (group: IGroup, q: IFormField, rowIndex?: number): AbstractControl => {
    return rowIndex != null ? group.formGroup.get(`${q.id}-${rowIndex}`) : group.formGroup.controls[q.id];
  }



  title() {
    if (!this.activeGroup) {
      return '';
    }
    const groupName = this.activeGroup.deleted ? this.activeGroup.deletedName :
      (this.activeGroup.question && this.activeGroup.question.isTab ?
        this.activeGroup.formGroup.controls[this.activeGroup.question.id].value :
        this.activeGroup.name);
    const subGroupName = this.activeGroup.activeSubGroup ? this.activeGroup.activeSubGroup.name : null;
    const title = [groupName, subGroupName].filter(x => x).join(' - ');
    if (!title) {
      // nothing selected, just show the subcategory name
      return this.subCategory.name;
    }
    return title;
  }

  // filters all warnings to selected group/subgroup
  initWarnings() {
    this.answerWarnings = [];

    const initAnswerWarnings = (a: IAnswer, q: Question) => {

      if (!a.answerWarnings || a.answerWarnings.length === 0) return undefined;

      a.answerWarnings.forEach(answerWarning => {
        // answerWarning.type = w.message;
        answerWarning.answer = a;
        answerWarning.question = q.question;
        answerWarning.questionId = q.id;
        if (!answerWarning.createdAtString) {
          answerWarning.createdAtString = moment(answerWarning.createdAt).format("MMMM Do YYYY, h:mm:ss a");
        }

        // find comments on the warning
        answerWarning.replies = [];
        a.comments.forEach(c => {
          if (c.answerWarningId === answerWarning.id) {
            answerWarning.replies.push(this.getCommentMeta(c));
          }
        });
        answerWarning.externalUrl = answerWarning.replies.find(c => !!c.externalUrl)?.externalUrl;
        answerWarning.replyTo = false;
        answerWarning.replyComment = { message: "", attachments: new Map() };
        const answerQuestion = answerWarning.answer ? this.questionsById[answerWarning.answer.questionId] : null;
        const parentQuestion = answerQuestion ? this.questionsById[answerQuestion.parentId] : null;
        const rowIndex = parentQuestion ? parentQuestion.answers.map(a => a.id).indexOf(answerWarning.answer.parentAnswerId) + 1 : null
        answerWarning.rowIndex = rowIndex ? rowIndex : null;
        this.answerWarnings.push(answerWarning);
      });
    };

    if (this.activeGroup.activeSubGroup) {
      const activeSg = this.activeGroup.activeSubGroup;
      if (activeSg.isTable && activeSg.activeRow != null) {
        // init warnings for every column in the active row
        activeSg.questions.forEach(q => initAnswerWarnings(activeSg.rows[this.activeGroup.activeSubGroup.activeRow].cells[q.id], q));
      } else {
        activeSg.questions.forEach(q => {
          q.answers.forEach(a => initAnswerWarnings(a, q));
        });
      }
    } else {
      this.activeGroup.subgroups.forEach(sg => {
        sg.questions.forEach(q => {
          q.answers.forEach(a => initAnswerWarnings(a, q));
        });
      });
    }
  }

  async saveAnsWarningReply(answerWarning: IAnswerWarning, comment: CommentValue, closeWarning: boolean) {
    this.replyingWarning = true;

    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subCategory.name, Array.from(comment.attachments.values()));
    if (!success) {
      this.replyingWarning = false;
      return;
    };

    const _comment: any = {
      message: comment.message,
      attachments,
      answerIds: [answerWarning.answerId],
      answerWarningId: answerWarning.id,
    };

    this.commentService.addComment(_comment).subscribe(
      (response: any) => {
        const newComment = response.comment;
        if (newComment && newComment.commentAudits && newComment.commentAudits.length) {
          newComment.commentAudits[0].user = response.user;
        }
        this.replyingWarning = false;
        handleUrlsForNewComment(this.taxReturnService, this.taxReturn, newComment).subscribe(hasNewDocs => {
          if (hasNewDocs) {
            this.onSubgroupChange();
          }
        });
        answerWarning.answer.comments.push(newComment);

        if (closeWarning) {
          this.answerService.updateAnswerWarning({
            answerWarningIds: [answerWarning.id],
            status: 1
          }).subscribe(() => {
            answerWarning.replyTo = false;
            answerWarning.replyComment = { message: "", attachments: new Map() };
            answerWarning.status = 1; // cause the count to update immediately
            this.getTaxReturn();
            setTimeout(() => {
              this.initWarnings();
            });
          })
        }else {
          answerWarning.replyTo = false;
          answerWarning.replyComment = { message: "", attachments: new Map() };
          setTimeout(() => {
            this.initWarnings();
          });
        }

      }, e => {
        this.replyingWarning = false;
      });
  }

  // get count of active answer warnings plus all unanswered mandatory fields
  // when getting total count for active group or subgroup, the answer warnings are already filtered on init
  activeAnsWarnings(all?: boolean): number {
    let count = all
      ? getActiveWarnings(this.taxReturn, this.subCategory)
      : this.answerWarnings.filter(aw => aw.status === 0).length;

    if (!all) {
      if (this.activeGroup && this.activeGroup.activeSubGroup) {
        const subGroupWarnings = (this.activeGroup.validationWarnings || []).filter(w => w.subGroupId === this.activeGroup.activeSubGroup.id);
        count += subGroupWarnings.length;
      } else if (this.activeGroup && this.activeGroup.validationWarnings) {
        count += this.activeGroup.validationWarnings.length;
      }
    }
    return count;
  }

  closedAnsWarnings(all?: boolean): number {
    let count = all ? getClosedWarnings(this.taxReturn, this.subCategory) : this.answerWarnings.filter(aw => aw.status !== 0).length;
    return count;
  }


  filterDocuments() {
    this.fileQuestion = [];
    const filteredDocuments: { [docId: string]: IDocumentMetadata } = {};
    const group = this.activeGroup;
    const accumulateDocumentsOnAnswers = (as,subgroupQuestions) => {
      as.forEach(a => {
        //count file question documents in selected subgroup
        const existFileQuestion = subgroupQuestions.find(q => q.id === a.questionId && q.displayFieldType === 'file' && a.answer)
        if (existFileQuestion) {
          this.fileQuestion.push(a.answer)
        }
        a.comments.forEach(c => c.documents.forEach(d => {
          filteredDocuments[d.id] = d;
        }))
      });
    };
    const accumulateDocumentsOnQuestions = qs => {
      qs.forEach(q => accumulateDocumentsOnAnswers(q.answers, qs));
    };
    if (group) {
      const subgroup = this.activeGroup.activeSubGroup;
      if (subgroup) {
        if (subgroup.isTable && subgroup.activeRow != null) {
          const activeRow = subgroup.rows[subgroup.activeRow];
          if (activeRow != null) {
            const answers = Object.values(activeRow.cells);
            accumulateDocumentsOnAnswers(answers, subgroup.questions);
          }
        } else {
          accumulateDocumentsOnQuestions(subgroup.questions);
        }
      } else {
        // no subgroup selected
        group.subgroups.forEach(sg => {
          accumulateDocumentsOnQuestions(sg.questions);
        });
      }
    }
    const docs = Object.values(filteredDocuments);
    this.filteredDocuments = docs.map(d => this.taxReturn.documents.find(doc => doc.id === d.id));
    this.fileQuestion.map(fq => {
      this.filteredDocuments.push({url: fq})
    })
  }

  countDocuments(all?: boolean): number {
    if (all) {
      return this.subCategory.documentCount;
    }
    return this.filteredDocuments.length;
  }


  initFlagsTab() {
    const initDropdown = () => {
      const valuesPlaceholder: {name: string, value: string, order?: number, select?: boolean}[] = [{
        name: "Select...",
        value: "",
        order: 0
      }];

      const flagTypes: {name: string, value: string, order?: number, select?: boolean}[] = this.flagTypes.flags.map(f => ({
        name: f.name, // the menu label
        value: `${f.id}`,
        selected: this.flagTypeId === f.id
      }));

      if (this.config.featureFlags.standardFlagAsDefault) {
        const standardFlag = flagTypes.find((fT) => fT.name === 'Standard Flag');
        if (!standardFlag) {
          throw new Error('standard flag is set as default but does not exist in the database');
        }
        this.flagTypeId = parseInt(standardFlag.value, 10);
        return;
      }
      setTimeout(() => {
        this.flagDropDown = $(this.flagDropDown.nativeElement).dropdown({
          values: valuesPlaceholder.concat(flagTypes),
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          direction: 'upward',
          onChange: (value: string) => this.flagTypeId = Number(value)
        });
      });

    };

    !this.flagTypes ? this.flagService.getFlags().subscribe((f: ListOfFlags) => {
      this.flagTypes = f;
      initDropdown();
    }) : initDropdown();

    setTimeout(() => $(".scroll-anchor").get(0)?.scrollIntoView());
  }


  // init all answer flags
  initFlags() {

    this.answerFlags = [];

    const initFlag = (a: IAnswer, q: Question, group?: IGroup, subgroup?: ISubGroup, rowIndex?: number) => {

      if (!a.answerFlags || a.answerFlags.length === 0) return undefined;

      a.answerFlags.forEach(aF => {

        const answerFlag: any = {
          ...aF,
          question: q,
          groupId: group ? group.id : null,
          subGroupId: subgroup ? subgroup.id : null,
          groupName: group ? (group.deleted ? group.deletedName : group.name) : null,
          subGroupName: subgroup ? subgroup.name : null,
          rowIndex: rowIndex,
          createdAtString: moment(aF.createdAt).format("MMMM Do YYYY, h:mm:ss a")
        };

        if (a.comments && a.comments.length > 0) {

          const flagComment = a.comments.find(c => c.answerFlagId === aF.id && !c.parentCommentId);

          if (flagComment) {
            answerFlag.parentComment = this.getCommentMeta(flagComment);
            // find replies to parent comment
            answerFlag.parentComment.comments = [];
            a.comments.forEach(cc => {
              if (cc.parentCommentId === answerFlag.parentComment.id)
                answerFlag.parentComment.comments.push(this.getCommentMeta(cc));
            });
            answerFlag.externalUrl = answerFlag.parentComment.comments.find(c => !!c.externalUrl)?.externalUrl;
          }
        }

        answerFlag.replyTo = false;
        answerFlag.replyComment = { message: "", attachments: new Map() };
        this.answerFlags.push(answerFlag);
      });
    };

    this.subCategory.groups.forEach(g => {
      g.subgroups.forEach(sg => {

        if (sg.isTable) {
          sg.rows.forEach((r, rowIndex) => {
            Object.keys(r.cells).forEach(qId => {
              const cellAns = r.cells[qId].id;
              if (cellAns) {
                const q = sg.questions.find(q => q.id === Number(qId));
                initFlag(r.cells[qId], q, g, sg, rowIndex);
              }
            });
          });
        } else {
          sg.questions.forEach(q => {
            q.answers.forEach(a => initFlag(a, q, g, sg));
          });
        }
      });

    });

  }

  initReviews() {
    const addOrReplaceEntryToArray = (newEntry, oldEntry) => {
      if(oldEntry) {
        // remove previous element before updating
        this.combinedReviewItems.splice(this.combinedReviewItems.indexOf(oldEntry), 1)
      }
      this.combinedReviewItems.push(newEntry);
    }

    this.answerWarnings.forEach(w =>{
      if (w.status === 0) {
        return;
      }
      const warning = this.combinedReviewItems?.find(r => r.warningId == w.id) || null;
      // if warning hasn't been updated
      if((warning) && w.updatedAt === warning.updatedAt) {
        return;
      }
      const reviewItem = {
        warningId: w.id,
        type:'warning',
        // It's safe to assume the warning is closed here because anything warning with a status
        // of 0 (open) gets skipped
        message: 'Closed Warning',
        warningMessage: w.warningMessage,
        replies: w.replies || [],
        questions: [{
          name: w.question,
          questionId: w.questionId,
          answerId: w.answerId,
          rowIndex: w.rowIndex
        }],
        updatedAt: w.updatedAt,
        createdAtString: w.createdAtString
      } as IReviewItem;
      addOrReplaceEntryToArray(reviewItem, warning);
    });

    this.answerFlagsFilteredClosed.forEach(f =>{
      const answerFlag = this.combinedReviewItems?.find(r => r.flagId == f.id) || null;
      // if flag hasn't been updated
      if((answerFlag) && f.updatedAt === answerFlag.updatedAt) {
        return;
      }
      const reviewItem = {
          flagId: f.id,
          type:'flag',
          message: f.flag.flagMessage,
          replies: f.parentComment?.comments || [],
          parentComment: f.parentComment,
          questions: [{
            name: f.question.question,
            questionId: f.question.id,
            answerId: f.answerId
          }],
          updatedAt: f.updatedAt,
          createdAtString: f.createdAtString,
          role: f.parentComment?.role
        } as IReviewItem;
        addOrReplaceEntryToArray(reviewItem, answerFlag);
    });

    this.comments.forEach(c => {
      const comment = this.combinedReviewItems?.find(r => r.commentId === c.id) || null;
      // if flag hasn't been updated
      if((comment) && c.updatedAt === comment.updatedAt) {
        return;
      }
      const reviewItem = {
        commentId: c.id,
        type:'comment',
        message: c.message,
        replies: c.comments,
        questions: c.commentFields.map((cf, index) =>
          ({ name: cf.question,
            questionId: cf.id,
            answerId: cf.answerId,
            rowIndex: cf.rowIndex,
            tooltipContent: c.commentFields[index]?.tooltipContent
          })
        ),
        updatedAt: c.dateMoment.utc().format(),
        createdAtString: c.date,
        commentFields: c.commentFields,
        author: c.author,
        role: c.role,
        comment: c
      } as IReviewItem;
      addOrReplaceEntryToArray(reviewItem, comment);
    });
  }

  filterFlags() {

    if (this.activeGroup) {

      this.answerFlagsFiltered = this.answerFlags.filter(aF => {
        return aF.groupId === this.activeGroup.id;
      });

      if (this.activeGroup.activeSubGroup) {
        this.answerFlagsFiltered = this.answerFlagsFiltered.filter(aF => {

          if (this.activeGroup.activeSubGroup.isTable && this.activeGroup.activeSubGroup.activeRow != null) {
            return aF.subGroupId === this.activeGroup.activeSubGroup.id && aF.rowIndex === this.activeGroup.activeSubGroup.activeRow;
          } else {
            return aF.subGroupId === this.activeGroup.activeSubGroup.id;
          }
        });

      }

    }

    setTimeout(() =>
      $("#flags-tab .labels .label").popup({
        position: "top center",
        inline: false,
        variation: "inverted",
      }));

  }


  // prevent flagging ans if answers have changed
  // answer id is required to flag, if question contains no ans, save empty ans first
  saveAnsFlag() {
    const flaggedAns = this.taxReturnSubcategoryService.getFlaggedAns();
    if (this.commentFields.length > 0) {
      return $(this.unsavedFieldsModal.nativeElement).modal('show');
    }
    if (this.groupQuestion && flaggedAns.groupId <= 0) {
      // trying to flag something on an unsaved-tab (but they must have backspaced the untitled tab name)
      const group = this.subCategory.groups.find(g => g.id === flaggedAns.groupId);
      const control = this.getFormControl(group, this.groupQuestion);
      control.setValue(this.defaultGroupName);
      return $(this.unsavedFieldsModal.nativeElement).modal('show');
    }

    this.isSaving = true;

    const addAnswerFlag = async (answerId) => {
      const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subCategory.name, Array.from(this.flagsComment.value.attachments.values()));
      if (!success) {
        this.isSaving = false;
        return;
      };

      this.commentService.addComment({
        answerIds: [answerId],
        flagId: this.flagTypeId,
        message: this.flagsComment.value.message,
        attachments,
      }).subscribe(() => {
        this.isSaving = false;
        this.unsaved = false;
        this.taxReturnSubcategoryService.setFlaggedAns(null);
        this.flagsComment.patchValue({
          message: '',
          attachments: new Map(),
        });
        this.isReady = false;
        this.getTaxReturn();
      }, e => {
        this.isSaving = false;
        this.unsaved = false;
      });
    };

    if (flaggedAns.answerId) {
      addAnswerFlag(flaggedAns.answerId);
    } else {
      const groupId = flaggedAns.groupId;
      const tableQuestionId = flaggedAns.parentId;

      if (!tableQuestionId) {
        // saving a non-table answer, use the groupId as the parentAnswerId
        this.answerService.addAnswer({
          answer: "",
          questionId: flaggedAns.id,
          taxReturnId: this.getTaxReturnIdForCategory(),
          parentAnswerId: groupId ? groupId : null,
        }).subscribe(answer => {
          addAnswerFlag(answer.id);
        }, e => {
          this.isSaving = false;
          this.unsaved = false;
        });
      } else {
        // saving a table-answer, the row answer may or may not exist
        const rowAnswer = flaggedAns.row && flaggedAns.row.rowAnswer;
        const newAnswerData = rowAnswer ? {
          questionId: flaggedAns.id,
          parentId: rowAnswer.id,
          answer: "",
        } : {
          questionId: tableQuestionId,
          parentId: groupId ? groupId : null,
          answer: "",
          overrideStatus: 0, // just adds a blank row, doesn't need to be an override given no answer change
          answers: [{
            questionId: flaggedAns.id,
            answer: "",
          }],
        };
        this.commentService.addCommentWithAnswers({
          comment: {
            createComment: false,
          },
          answers: [newAnswerData],
          taxReturnId: this.getTaxReturnIdForCategory(),
        }).subscribe(r => {
          const answerId = rowAnswer ? r.answers[0].id : r.answers[0].answers[0].id;
          addAnswerFlag(answerId);
        }, e => {
          this.isSaving = false;
          this.unsaved = false;
        });
      }
    }
  }

  // submit a comment reply
  async replyToFlag(answerFlag: IAnswerFlag, closeFlag?: boolean) {
    this.replyingFlag = true;

    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subCategory.name, Array.from(answerFlag.replyComment.attachments.values()));
    if (!success) {
      this.replyingFlag = false;
      return;
    };

    const _comment: any = {
      parentCommentId: answerFlag.parentComment.id,
      message: answerFlag.replyComment.message,
      attachments,
      answerIds: [answerFlag.answerId],
    };

    this.commentService.addComment(_comment).subscribe((response: any) => {
      this.replyingFlag = false;
      const newComment = response.comment;
      if (newComment && newComment.commentAudits && newComment.commentAudits.length) {
        newComment.commentAudits[0].user = response.user;
      }
      handleUrlsForNewComment(this.taxReturnService, this.taxReturn, newComment).subscribe(hasNewDocs => {
        if (hasNewDocs) {
          this.onSubgroupChange();
        }
      });

      // append reply to parent comment
      answerFlag.parentComment.comments.push(this.getCommentMeta(newComment));

      if (closeFlag) {
        this.answerService.updateAnswerFlag({
          answerFlagIds: [answerFlag.id],
          status: 99
        }).subscribe(() => {
          answerFlag.replyTo = false;
          answerFlag.replyComment = { message: "", attachments: new Map() };
          answerFlag.status = 99;

          this.subCategory.groups.forEach(g => {
            g.subgroups.forEach(sg => {
              sg.questions.forEach(q => {
                q.answers.forEach(a => {
                  if (a.id === answerFlag.answerId) {
                    const aFlag = a.answerFlags.find(aF => aF.id === answerFlag.id);
                    aFlag.status = 99;
                  }
                });
              });
            });
          });
        });
      } else {
        answerFlag.replyTo = false;
        answerFlag.replyComment = { message: "", attachments: new Map() };
      }
    }, e => {
      this.replyingFlag = false;
    });
  }

  // get count of active answer flags
  // when getting total count for active group or subgroup, the flags are already filtered on init
  activeAnsFlags(all?: boolean): number {

    if (all) {
      let count = 0;
      this.subCategory.groups && this.subCategory.groups.forEach(g =>
        g.subgroups && g.subgroups.forEach(sg =>
          sg.questions && sg.questions.forEach(q =>
            q.answers && q.answers.forEach(a =>
              a.answerFlags && a.answerFlags.forEach(aF => aF.status === 0 ? count++ : undefined)))));
      return count;
    } else {
      return this.answerFlagsFiltered.filter((aF: IAnswerFlag) => aF.status === 0).length;
    }
  }
// get count of closed answer flags
  closedAnsFlags(all?: boolean): number {
    if (all) {
      let count = 0;
      this.subCategory.groups && this.subCategory.groups.forEach(g =>
        g.subgroups && g.subgroups.forEach(sg =>
          sg.questions && sg.questions.forEach(q =>
            q.answers && q.answers.forEach(a =>
              a.answerFlags && a.answerFlags.forEach(aF => aF.status !== 0 ? count++ : undefined)))));
      return count;
    } else {
      this.answerFlagsFilteredClosed = this.answerFlagsFiltered.filter((aF: IAnswerFlag) => aF.status !== 0);
      this.initReviews();
      return this.answerFlagsFilteredClosed.length;
    }
  }

  unFlagAns() {
    this.taxReturnSubcategoryService.setFlaggedAns(null);
  }

  isBooleanCheckboxColumn(q: IFormField) {
    return q.displayFieldType === 'checkbox' && q.dataType === 'boolean';
  }

  loadTrace({ question, answer }) {
    // reset state
    this.trace = null;
    this.traceQuestion = null;
    this.traceAnswer = null;
    // this.traceNotAvailable = false;
    if (this.loadingTrace) {
      this.loadingTrace.unsubscribe();
      this.loadingTrace = null;
    }
    // now load the trace
    if (question && answer) {
      this.loadingTrace = this.answerService.getAnswerTraceForAnswerId(answer.id).subscribe((trace: any) => {
        this.loadingTrace = null;
        this.traceQuestion = question;
        this.traceAnswer = answer;

        const snapshot = this.taxReturn.snapshot;
        if (snapshot) {
          // A trace is still valid if updatedAt was before the snapshot createdAt
          const date = moment(trace.updatedAt);
          if (moment(trace.updatedAt).isBefore(moment(snapshot.createdAt))) {
            this.trace = trace;
          }
        } else {
          this.trace = trace;
        }
      }, e => {
        this.loadingTrace = null;
        this.traceQuestion = question;
        this.traceAnswer = answer;
      });
    } else if (question) {
      this.traceQuestion = question;
    }
  }

  answerSelected: Function = (groupId: number, subgroup: ISubGroup, question, answer?: IAnswer, rowIndex?: number, row?: any): void => {
    // load trace
    if (this.rightSideTab === 'calculation') {
      this.loadTrace({ question, answer });
    } else if (this.tab === 3 && !this.debug) {
      // flag answer
      if (!this.readonly()) {
        const flagAns = cloneDeep(question);
        flagAns.answerId = answer && answer.id;
        flagAns.groupId = groupId;
        if (subgroup) {
          flagAns.subGroupId = subgroup.id;
          flagAns.subGroupName = subgroup.name;
        }
        if (rowIndex != null) {
          flagAns.rowIndex = rowIndex;
        }
        flagAns.row = row;
        this.taxReturnSubcategoryService.setFlaggedAns(flagAns);
      }
    } else if (this.tab === 2 && !this.readonly() && !this.debug) {
      // comment
      const commentField = cloneDeep(question);
      commentField.rowIndex = rowIndex;
      commentField.groupId = groupId;
      if (!subgroup) {
        const group = this.subCategory.groups.find(g => g.id === groupId);
        const groupName = group.deleted ? group.deletedName : group.name;
        commentField.groupName = groupName;
      }
      if (subgroup) {
        commentField.subGroupId = subgroup.id;
        commentField.subGroupName = subgroup.name;
      }
      this.taxReturnSubcategoryService.addCommentField(commentField);
    }
  }

  applyDebug() {
    if (this.debug) {
      this.taxReturn.questions.forEach(q => {
        q.actualHidden = q.hidden;
        q.hidden = false;
        q.showTag = q.tag;
        q.debugLinks = true;
      });
      this.taxReturn.categories.forEach(c => c.subcategories.forEach(sc => {
        sc.questions.forEach(q => {
          q.actualHidden = q.hidden;
          q.hidden = false;
          q.showTag = q.tag;
          q.debugLinks = true;
        });
        sc.groups.forEach(g => g.subgroups.forEach(sg => {
          if (sg.question) {
            sg.question.hidden = false;
          }
          sg.questions.forEach(q => {
          q.actualHidden = q.hidden;
          q.hidden = false;
          q.showTag = q.tag;
          q.debugLinks = true;
          })
        }));
      }));
    } else {
      this.taxReturn.questions.forEach(q => {
        q.showTag = undefined;
        q.debugLinks = false;
      });
      this.taxReturn.categories.forEach(c => c.subcategories.forEach(sc => {
        sc.questions.forEach(q => {
          q.showTag = undefined;
          q.debugLinks = false;
        });
        sc.groups.forEach(g => g.subgroups.forEach(sg => sg.questions.forEach(q => {
          q.showTag = undefined;
          q.debugLinks = false;
        })));
      }));
    }
  }

  resolveDocuments() {
    if (this.taxReturn.documents && this.taxReturn.documents.length) {
      resolveDocuments(this.taxReturnService, this.taxReturn).subscribe(() => {
        // refresh warnings/flags
        this.onSubgroupChange();
      });
    }
  }

  deleteCommentField(commentField: ICommentField) {
    this.taxReturnSubcategoryService.removeCommentField(commentField);
  }

  showNotes() {
    $(this.notesModalEl.nativeElement).modal({
      autofocus: false
    }).modal("show");
  }

  updateNotesCount(count: number) {
    this.subCategory.notesCount = count;
  }

  selectTab(tab: number) {
    this.tab = tab;
    this.taxReturnSubcategoryService.selectTab(tab);
  }

  disableClearOverRides() {
    return (this.isSyncingAps || this.isRunningCalcs || this.isClearingOverrides || this.commentFields.length > 0);
  }

  updateOverRideFlag() {
    if (this.overRideFlag === 'CLEAR SUBCATEGORY') {
      this.clearOverrides();
      this.overRideForm.get('overRide')?.setValue('');
    } else if (this.overRideFlag === 'SINGLE ANSWER' ) {
      this.showSingleAnswerOverRideModal();
    }
  }

  hideOverrideIcon() {
    return (!this.disableClearOverRides() && this.overRideFlag !== 'SINGLE ANSWER');
  }

  refreshTaxReturn() {
    this.isReady = false;
    this.getTaxReturn();
  }

  getClientRulesWarning() {
    return getClientRulesWarningMsg(this.taxReturn.mandatoryIncompleteClientRulesCount);
  }

  handleToggleFullScreen({ requiresFullScreen, subGroupId }) {
    this.isFullScreenMode = requiresFullScreen;
    if (requiresFullScreen) {
      const subGroup = this.subCategory?.groups?.map(g => g.subgroups).flat().find(sg => sg.id === subGroupId);
      this.previousSideOpen = this.sideOpen;
      this.sideOpen = false;
      this.fullScreenSubGroup = subGroup;
    } else {
      this.fullScreenSubGroup = null;
      this.sideOpen = this.previousSideOpen;
    }
  }

  handleSideOpen() {
    this.sideOpen = this.sideOpen ? !this.sideOpen : true;
  }

  updateBorderType(element, type) {
    // Remove all previously added type-specific classes
    element.classList.remove('warning', 'comment', 'flag');

    // Add the correct class based on the type argument
    switch (type) {
      case 'warning':
        element.classList.add('warning'); // Adds the 'warning' class
        break;
      case 'comment':
        element.classList.add('comment'); // Adds the 'comment' class
        break;
      case 'flag':
        element.classList.add('flag'); // Adds the 'flag' class
        break;
      default:
        // console.warn('Unknown type:', type);
        break;
    }
  }


  setfocusOnQuestion(questionId, type:string, answerId){
    const divToScroll = 'question-input-' + questionId;
    const container = document.getElementById('question-' + questionId);
    const containerRect = this.scrollContainer.nativeElement.getBoundingClientRect();

    if (divToScroll && document.getElementById(divToScroll) && container) {
      const inputElement = document.getElementById(divToScroll);
      // listens to clicks (mousedown) outside of the element and removes the highlighting
      const handleClickOutside = (event: MouseEvent) => {
        if (!container?.contains(event.target as Node)) {
          document.removeEventListener('mousedown', handleClickOutside); // Clean up
          container.classList.remove('highlightWarningCommentFlags');
          this.updateBorderType(container, '');
        }
      }

      // Scroll into view and focus after setting up event listeners
      const inputRect = container.getBoundingClientRect();
      // Calculate the offset inside the container
      this.lastScrollPosition = inputRect.top - containerRect.top + this.scrollContainer.nativeElement.scrollTop;
      // Scroll the container
      this.scrollContainer.nativeElement.scrollTo({
        top: this.lastScrollPosition,
        behavior: 'smooth'
      });
      // Tab index has been applied to the input element so that it tracks whether it should be focusable
      const inputTabIndex = inputElement.attributes?.getNamedItem("tabindex")?.nodeValue;
      if(inputTabIndex === "0") {
        inputElement.focus();
      }
      container.classList.add('highlightWarningCommentFlags');
      this.updateBorderType(container, type);
      setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
      }, 0);
    }
    // focus on table
    const tblToScroll = 'question-table-warning-' + questionId +'-'+ answerId;
    if(tblToScroll && document.getElementById(tblToScroll) ){
      const inputTblTdElement = document.getElementById(tblToScroll) ;
      const hadActiveWarningClass = inputTblTdElement.classList.contains('active-warning');
      const hadErrorClass = inputTblTdElement.classList.contains('error');

      inputTblTdElement.addEventListener('focus', () => {
        inputTblTdElement.classList.add('highlightWarningCommentFlags');
        this.updateBorderType(inputTblTdElement, type);
        // remove these classes as they are marked as important
        inputTblTdElement.classList.remove('active-warning');
        inputTblTdElement.classList.remove('error');
      });
      inputTblTdElement.addEventListener('blur', () => {
        inputTblTdElement.classList.remove('highlightWarningCommentFlags');
        if(hadActiveWarningClass) {
          inputTblTdElement.classList.add('active-warning');
        }
        if(hadErrorClass) {
          inputTblTdElement.classList.add('error');
        }
        inputTblTdElement.removeAttribute('tabindex');
      });
      inputTblTdElement.setAttribute('tabindex', '-1');
      inputTblTdElement.focus();
      inputTblTdElement.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'})
      const table1 = inputTblTdElement.closest('table');
      if (table1) {
        // Scroll the table to the top
        this.lastScrollPosition = this.scrollContainer.nativeElement.scrollTop;
        // Scroll the container
        this.scrollContainer.nativeElement.scrollTo({
          top: this.lastScrollPosition,
          behavior: 'smooth'
        });

        // set table position scroll
        let tblIndex = null;
        const virtualScroller = inputTblTdElement.closest('app-virtual-scroller');
        const scrollerClassName = virtualScroller.className;
        this.scrollableElements.forEach((elementRef, index) => {
          if(elementRef?.nativeElement?.className == scrollerClassName){
            tblIndex = index;
          }
        });
        if(tblIndex) {
          const rowNumWidth = $(document.getElementsByClassName("row-num sticky"))[0]?.offsetWidth;
          const tableHeaderHeight = $("th:first")[0]?.offsetHeight;

          const tableTopLeftPositionX = virtualScroller.getBoundingClientRect().left + rowNumWidth;
          const tableTopLeftPositionY = virtualScroller.getBoundingClientRect().top + tableHeaderHeight + 2;

          const requiredScrollOffsetX = inputTblTdElement.getBoundingClientRect().left - tableTopLeftPositionX;
          const requiredScrollOffsetY = inputTblTdElement.getBoundingClientRect().top - tableTopLeftPositionY;

          const currentScrollX = virtualScroller.scrollLeft;
          const currentScrollY = virtualScroller.scrollTop;

          this.scrollLeftPositions.set(tblIndex, currentScrollX + requiredScrollOffsetX);
          this.scrollPositions.set(tblIndex, currentScrollY + requiredScrollOffsetY);
        }
      }
    }
  }

  setfocusOnQuestionChildComp(data: IQuestionFocus)
  {
    this.setfocusOnQuestion(data.id, data.type, data?.answerId)
  }

  initComments() {
    this.comments.length = 0;
    this.subCategory.groups.forEach(g => {
      g.subgroups.forEach(sg => sg.questions.forEach(q => this.initComment(q, g, sg)));
      // only take the comment from the top-level if it didn't exist in a subgroup
      if (g.question && !g.subgroups.some(sg => sg.questions.some(q => q.id === g.question.id))) {
        this.initComment(g.question, g, null);
      }
    })
    this.mapTooltip();
  }

  // show comments for all answers, not just the most recent answer
  // adapted from comments.component.ts
  initComment(q: any, group?: any, subgroup?: any, smartFormCategoryId?: any) {

    // finds the nearest answer audit relative the comment,
    // max 1 second either side of comment creation date
    const nearest = (answerAudits, comment: IComment) => {
      const commentWithNearestAudit = cloneDeep(comment);
      let closestMs = null;
      answerAudits.forEach(answerAudit => {
        const duration = moment.duration(moment(answerAudit.createdAt).diff(moment(comment.createdAt)));
        const durationMs = Math.abs(duration.asMilliseconds());
        if (durationMs < 2000 && (closestMs == null || durationMs < closestMs)) {
          // @ts-ignore TODO -fix types. Types don't properly include the `nearestAudit` property
          commentWithNearestAudit.nearestAudit = cloneDeep(answerAudit);
          closestMs = durationMs;
        }
      });
      return commentWithNearestAudit;
    };

    if (q.answers && q.answers.length > 0) {

      q.answers.forEach((a, i) => {
        if ((a.comments || []).length > 0) {

          // start with top level comments
          a.comments.forEach(c => {

            // filter out answer warning and flag comments
            if (c.parentCommentId || c.answerWarningId || c.answerFlagId) return false;

            // note: tab questions will not return subgroup data
            const commentField: ICommentField = {
              id: q.id,
              question: q.question,
              groupId: group ? group.id : null,
              subGroupId: subgroup ? subgroup.id : null,
              groupName: group ? (group.deleted ? group.deletedName : group.name) : null,
              subGroupName: subgroup ? subgroup.name : null,
              smartFormCategoryId: smartFormCategoryId ? smartFormCategoryId : null
            };


            // append old/new answer to popup
            const ansAudits = a.answerAudits.filter(aA => aA.answerId === a.id);
            if (ansAudits.length > 1) {
              const commentWithNearestAudit = nearest(a.answerAudits, c);
              // @ts-ignore TODO -fix types. Types don't properly include the `nearestAudit` property
              if (commentWithNearestAudit && commentWithNearestAudit.nearestAudit) {
              // @ts-ignore TODO -fix types. Types don't properly include the `nearestAudit` property
                if (commentWithNearestAudit.nearestAudit.oldAnswer) {
              // @ts-ignore TODO -fix types. Types don't properly include the `nearestAudit` property
                  commentField.valueChange = `(answer changed from '${commentWithNearestAudit.nearestAudit.oldAnswer}' to '${commentWithNearestAudit.nearestAudit.newAnswer}')`;
              // @ts-ignore TODO -fix types. Types don't properly include the `nearestAudit` property
                } else if (commentWithNearestAudit.nearestAudit.newAnswer) {
              // @ts-ignore TODO -fix types. Types don't properly include the `nearestAudit` property
                  commentField.valueChange = `(saved answer '${commentWithNearestAudit.nearestAudit.newAnswer}')`;
                }
              }
            }

            // append row for table questions
            if (subgroup.isTable) {
              const rowIndex = subgroup.rows.findIndex(r => r.cells[q.id].id === a.id);
              commentField.rowIndex = rowIndex;
              commentField.answerId= a?.id || null;
            }

            // only append unique comments
            const commentInArr = this.comments.find(_c => _c.id === c.id);

            if (commentInArr) {
              commentInArr.commentFields.push(commentField);
            } else {
              const parentC: any = this.getCommentMeta(c);
              parentC.commentFields = [commentField];
              parentC.comments = [];
              this.comments.push(parentC);
            }

          });

          // now find all the replies to each comment
          a.comments.forEach(c => {
            if (c.parentCommentId && !c.answerWarningId) {
              const parentC = this.comments.find(_c => _c.id === c.parentCommentId);
              if (parentC && !parentC.comments.find(_c => _c.id === c.id)) {
                parentC.comments.push(this.getCommentMeta(c));
              }
            }
          });

        }

      });

    }
  }

  // adapted from comments.component.ts
  private mapTooltip() {
    this.comments.map(comment => {
      comment.commentFields.map(field => {
        field.tooltipContent = `${field.groupName ? field.groupName : ''}${field.groupName && field.subGroupName ? ' - ' : ''}
        ${field.subGroupName}${field.rowIndex != null ? ' - row ' + (field.rowIndex + 1) : ''}
        ${field.valueChange ? field.valueChange : ''}`;
      });
    });
  }

  // submit a comment reply
  // adapted from comments.component.ts
  async saveCommentReply(comment: IComment) {
    this.isSavingReply = true;
    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subCategory.name, Array.from(comment.replyComment.attachments.values()));
    if (!success) {
      this.isSavingReply = false;
      return;
    };

    const _comment: any = {
      parentCommentId: comment.id,
      message: comment.replyComment.message,
      attachments,
      answerIds: []
    };

    this.subscriptions.push(this.commentService.addComment(_comment).subscribe((response: any) => {
      const newComment = response.comment;
      if (newComment && newComment.commentAudits && newComment.commentAudits.length) {
        newComment.commentAudits[0].user = response.user;
      }

      // push into comments replies arr
      this.pushComments(newComment);

      this.isSavingReply = false;
      comment.replyTo = false;
      comment.replyComment = { message: "", attachments: new Map() };
      this.updateCommentsCount();
      let totalComments = this.comments.length;

    // include comment replies in total count
    this.comments.forEach((comment: IComment) => totalComments += comment.comments.length);
    this.updateGroupCommentsCount(totalComments);
    },
      () => {
        this.isSavingReply = false;
      }));

  }

  handleCommentReply(newComment: IComment) {
    handleUrlsForNewComment(this.taxReturnService, this.taxReturn, newComment).subscribe(hasNewDocs => {
      if (hasNewDocs) {
        this.onSubgroupChange();
      }
    });
  }

  setModal(src?: string) {
    this.modalImgSrc = src ?? null;
  }

  cancelReply(comment: IComment) {
    comment.replyTo = false;
    comment.replyComment = { message: "", attachments: new Map() };
  }

  showSendToClientButton(info) {
    return false
    // Hiding the send to client button, till the MI feature is supported.
    // if (this.tab === 1) {
    //   return (
    //     info.status === 0 &&
    //     !info.rowIndex &&
    //     !this.questionsById[info.questionId].hidden &&
    //     this.visibleQuestions[info.questionId]
    //   )
    // }else if (this.tab === 3) {
    //   return (
    //     info.status === 0 &&
    //     !info.rowIndex &&
    //     info.flagId === 2 &&
    //     !info.question.hidden &&
    //     this.visibleQuestions[info.question.id]
    //   )
    // }else {
    //   return false
    // }
  }
}
